/* Ripped Lab — Meal Plan Solver (Φάση 2, v3 — «κλειδωμένα πρώτα, λύσε — μη δηλώνεις», 9/9/2026, σχέδιο docs/research/10-solver-v3-spec.md)
   Υλοποιεί το Reference Manual §8-13: ρόλους τροφών (§9.14), locked κανόνες (§9.1-9.8),
   ισοκατανομή πρωτεΐνης (§9.9) ΜΕ global εξισορρόπηση ημέρας, λιπαρά §9.6 με αυτόματη
   προσθήκη healthy fats, εξαίρεση whey §9.7 (με ρητό flag), κατανομή υδατανθράκων §9.15,
   feasibility §9.11, σύγκρουση κανόνων §9.12, containers §10.1, όρια §11 (±25 kcal, ±3g P/F).
   Ο σολομός §9.1 επιλέγεται global: δοκιμάζονται 125/250 και κρατιέται το καλύτερο πλάνο.
   Όλα client-side. Εκτίθεται ως window.RLPlan για tests & UI. */
(function () {
  'use strict';

  /* ---------- Βάση τροφών (από Calories_Food_Categories.xlsx) ----------
     5/9/2026 (owner, brief 02): όλα ωμά/ξηρά ανά 100 g, υδατάνθρακες ΧΩΡΙΣ ίνες (ετικέτα ΕΕ), λάδι ανά g.
     Οι επώνυμες τιμές είναι από τις ετικέτες του owner και ΔΕΝ αλλάζουν χωρίς «ναι» του. */
  /* role: main | tier2 | secondary | carb | fat | veg | extra | container
     όρια ανά γεύμα σε g εκτός αν type=container (μονάδες) */
  var FOODS = {
    'Κοτόπουλο Στήθος':      { kcal:109, p:20.0, c:0,    f:1.4,  role:'main',      min:150, max:400, piece:272 }, /* 9/9/2026 (owner Ζ.2): ελάχιστο 150 g ωμό — ήταν 200 (manual §9.2, εκκρεμεί το κείμενο) */
    'Μοσχάρι Φιλέτο':        { kcal:121, p:22.0, c:0,    f:3.0,  role:'main',      min:150, max:400, piece:168 }, /* 9/9/2026 (owner Ζ.2): ελάχιστο 150 g ωμό — ήταν 200 (manual §9.3, εκκρεμεί το κείμενο) */
    'Γαλοπούλα Αλλαντικό':   { kcal:93,  p:13.0, c:4.5,  f:2.5,  role:'secondary', min:30, ideal:90, max:120, piece:30 }, /* Π9 (owner Α29, 5/9/2026): υλικό τοστ, όχι κύρια· ~3 φέτες· = Creta Farms Εν Ελλάδι καπνιστή με ελαιόλαδο (OFF 5202575007773, brief 02 Θ) */
    'Γαλοπούλα Καπνιστή Στήθος': { kcal:132, p:29.5, c:0.9, f:1.1, role:'secondary', min:30, ideal:90, max:120 }, /* 5/9/2026 brief 02 Θ (owner ναι): ΑΓΡΟΚΤΗΜΑ ΑΝΑΒΡΑ ατόφιο φιλέτο 90 % — Σκλαβενίτης + ΑΒ (3η πηγή: φωτογραφία ετικέτας εκκρεμεί)· ίδια όρια με Α29 */
    'Γαλοπούλα Στήθος':      { kcal:110, p:23.8, c:0,    f:1.5,  role:'main',      min:200, max:400 }, /* 5/9/2026 brief 02: USDA 171098 + Swiss 713 + Ciqual 36304 (Α5) */
    'Σολωμός':               { kcal:197, p:19.4, c:0,    f:13.3, role:'main',      locked:[125,250], piece:125, exact:true },
    'Τόνος':                 { kcal:101, p:24.0, c:0,    f:0.5,  role:'main',      locked:[112,224], piece:112, exact:true }, /* 6/9/2026 (owner Γ2, 08 #1): 1 ή 2 κονσέρβες στραγγισμένες (112 g) — κλειδωμένο όπως ο σολομός */
    'Γαρίδες':               { kcal:97,  p:20.3, c:0,    f:1.7,  role:'main',      min:150, max:400, piece:25 },
    'Συκώτι':                { kcal:135, p:20.4, c:3.9,  f:3.6,  role:'main',      min:150, max:300 },
    'Φακές':                 { kcal:298, p:24.0, c:48.8, f:2.0,  role:'main',      minM:80, minF:60, max:200, legume:true, piece:192, cup:true, gi:'slow' },
    'Ρεβύθια':               { kcal:346, p:21.0, c:42.0, f:6.6,  role:'main',      minM:80, minF:60, max:200, legume:true, piece:200, cup:true, gi:'slow' },
    'Φασόλια Χάντρες':       { kcal:343, p:23.0, c:45.1, f:1.2,  role:'main',      minM:80, minF:60, max:200, legume:true, piece:202, cup:true, gi:'slow' },
    'Σαρδέλα':               { kcal:208, p:24.6, c:0,    f:11.5, role:'main',      min:150, max:400 }, /* 11/9/2026 (owner, 14): ΦΡΕΣΚΙΑ ωμή καθαρισμένη· τιμή owner (σύμβαση §8.1.1, = USDA 175139 στραγγισμένη)· Ciqual 26065 ωμή 160/19,5/0/9,2· εβδομάδα: κανόνας ΠΟΙΚΙΛΙΑΣ 1 γεύμα (batch «εβδομάδα»), ΟΧΙ όριο υδραργύρου */
    'Chicken Fingers':       { kcal:190, p:17.5, c:13.3, f:7.4,  role:'main',      min:100, max:300, piece:21 }, /* = ΑΒ Επιλογή Chicken Fingers 400 g (owner 5/9/2026)· η σελίδα ΑΒ δηλώνει σήμερα 265/14,6/37,1/6,4 — τιμές owner μένουν (brief 02 Θ) */
    'Fish Fillet':           { kcal:216, p:12.0, c:21.0, f:9.1,  role:'main',      min:100, max:300, piece:28, exact:true }, /* = Captain Iglo Ψαροκροκέτες 15×28 g (Σκλαβενίτης, ταυτίζεται 100 %, owner 5/9/2026) */
    'Φιλετάκια Κοτόπουλου Ψητά': { kcal:106, p:18.0, c:1.8, f:3.0, role:'main',    min:100, max:300 }, /* 5/9/2026 brief 02 Θ (owner ναι): ΥΦΑΝΤΗΣ Απλά Γευστικό 390 g, 90 % στήθος, χωρίς πανέ — Σκλαβενίτης + ΑΒ (3η πηγή: ετικέτα εκκρεμεί) */
    'Φέτα Ήπειρος Slim':     { kcal:140, p:21.0, c:0.4,  f:6.0,  role:'tier2',     min:30,  max:120, piece:38 },
    'Μοτσαρέλα':             { kcal:247, p:18.0, c:7.0,  f:19.0, role:'tier2',     min:30,  max:125, piece:125, exact:true },
    'Τυρί Νουνού Light':     { kcal:235, p:31.0, c:0,    f:11.3, role:'tier2',     min:30,  max:100, piece:20 }, /* 20 g/φέτα (owner 5/9/2026) */
    'Ταλαγάνι':              { kcal:317, p:18.0, c:2.7,  f:26.0, role:'tier2',     min:30,  max:100, piece:100 },
    /* §9.8 (04/09/2026): ideal = ρεαλιστική μερίδα/γεύμα, max = ακραίο· §9.8.2 σκάλα πριν την υπέρβαση του ideal.
       piece = g ανά μονάδα (§9.10, USDA/συσκευασία)· exact = συσκευασία σταθερού βάρους (χωρίς «~») */
    'Γιαούρτι Νουνου 1.5%':  { kcal:72,  p:10.3, c:4.3,  f:1.5,  role:'secondary', min:100, ideal:300, max:450, piece:200, exact:true },
    'Γιαούρτι Κρι Κρι High Protein 0%': { kcal:59, p:10.3, c:4.5, f:0, role:'secondary', min:100, ideal:205, max:410, piece:205, exact:true }, /* 5/9/2026 brief 02: krikri.gr + Σκλαβενίτης + OFF 5202234610948 */
    'Αυγά Ασπράδι':          { kcal:55,  p:10.9, c:1.0,  f:0,    role:'secondary', min:66,  ideal:200, max:300, piece:33 },
    'Αυγό Ολόκληρο':         { kcal:139, p:12.6, c:0.3,  f:9.5,  role:'secondary', min:50,  ideal:100, max:100, piece:50, yolkEq:0.34 }, /* 5/9/2026 brief 02: USDA 171287 + CoFID 12-937 + Swiss 290 + Ciqual 22000· 1 αυγό = 17 g κρόκος → κοινό ταβάνι §9.6 (Α6) */
    'Πρωτεΐνη Whey Isolate': { kcal:373, p:90.0, c:2.5, f:0.1, role:'secondary', min:15, max:45, wheyCap:true, piece:25, exact:true },
    'Cottage 4%':            { kcal:100, p:12.0, c:2.4,  f:4.0,  role:'secondary', min:100, ideal:200, max:300, piece:200, exact:true },
    'Γάλα Light':            { kcal:46,  p:3.3,  c:4.7,  f:1.5,  role:'secondary', min:100, ideal:200, max:300, piece:250, gi:'slow' }, /* 8/9/2026 (owner): ιδανικό 1 ποτήρι — στη σκάλα δευτερευουσών όπως το γιαούρτι */ /* = ΔΕΛΤΑ ελαφρύ 1,5 % (OFF 5201037508902, brief 02 Θ) */
    'Γάλα Protein Plus':     { kcal:52,  p:5.0,  c:4.6,  f:1.5,  role:'secondary', min:100, ideal:200, max:300, piece:250 }, /* 8/9/2026 (owner): ιδανικό 200 g */ /* 5/9/2026 brief 02 Θ (owner ναι): ΔΕΛΤΑ μμμMILK Protein Plus 1,5 % — ΑΒ (2η/3η πηγή: ετικέτα εκκρεμεί) */
    'Ενταμάμε Φασόλια':      { kcal:135, p:12.0, c:13.0, f:3.6,  role:'secondary', min:50,  ideal:150, max:250, gi:'slow' },
    'Βρώμη':                 { kcal:372, p:13.5, c:58.7, f:7.0,  role:'carb', min:20, max:150, piece:81, cup:true, gi:'slow' },
    'Ρύζι Μπασμάτι':         { kcal:132, p:3.1,  c:29.1, f:0.2,  role:'carb', min:50, ideal:250, max:400, piece:185, cup:true, gi:'mid' }, /* 6/9 (owner B7): ιδανικό 250/γεύμα, πάνω από αυτό 2ος υδατάνθρακας */
    'Πατάτα':                { kcal:77,  p:2.1,  c:15.4, f:0.1,  role:'carb', min:100, ideal:400, max:500, piece:213, gi:'fast' }, /* 6/9 (owner B7): ιδανικό 400 */
    'Γλυκοπατάτα':           { kcal:86,  p:1.6,  c:17.1, f:0.1,  role:'carb', min:100, ideal:400, max:500, piece:130, gi:'mid' }, /* 6/9: όπως η πατάτα (B7) */
    'Μακαρόνια Fitness':     { kcal:359, p:18.1, c:65.6, f:2.0,  role:'carb', min:40, max:200, piece:91, cup:true, gi:'slow' },
    'Ψωμί Τόστ':             { kcal:258, p:10.8, c:44.3, f:3.5,  role:'carb', min:25, max:120, piece:25, gi:'fast' }, /* 5/9/2026 brief 02 Θ (owner «όποιο θέλεις»): ΚΑΤΣΕΛΗΣ Διπλοζυμωτό Τοστ Σταρένιο 500 g — Σκλαβενίτης + ΑΒ + OFF 5201673006572· ήταν 262/9,2/48,3/3 (άγνωστη μάρκα) */
    'Τορτίγια Ολικής':       { kcal:301, p:9.7,  c:53.0, f:7.6,  role:'carb', min:40, max:120, piece:40, exact:true, gi:'slow' }, /* = EL SABOR Wholemeal Wraps 8×40 g (Σκλαβενίτης, ταυτίζεται 100 %, brief 02 Θ)· piece 45→40 */
    'Τορτίγια Protein':      { kcal:315, p:17.9, c:43.4, f:6.5,  role:'carb', min:62.5, max:125, piece:62.5, exact:true, gi:'mid' }, /* 5/9/2026 brief 02 Θ (owner ναι): ΚΑΡΑΜΟΛΕΓΚΟΣ Αξιαγάπητες Tortillas Protein 6×62,5 g — mymarket + ΑΒ (3η πηγή: ετικέτα εκκρεμεί) */
    'Κινοα':                 { kcal:368, p:14.0, c:57.0, f:6.1,  role:'carb', min:40, max:200, piece:170, cup:true, gi:'slow' },
    'Egg Noodles':           { kcal:317, p:10.1, c:62.3, f:2.4,  role:'carb', min:40, max:200, piece:56, gi:'slow' },
    'Νιοκι Πατατας':         { kcal:155, p:3.3,  c:32.0, f:1.0,  role:'carb', min:80, max:350, gi:'mid' },
    'Φοκάτσια':              { kcal:243, p:7.1,  c:45.7, f:2.7,  role:'carb', min:40, max:150, gi:'fast' },
    'Ποπ Κορν':              { kcal:365, p:9.4,  c:74.3, f:4.7,  role:'carb', min:10, max:60, piece:16, gi:'mid' },
    'Κρακερς':               { kcal:439, p:12.0, c:67.0, f:13.0, role:'carb', min:10, max:60, piece:11.5, gi:'mid' }, /* 5/9/2026 brief 02 Θ (owner «όποιο θέλεις»): ΠΑΠΑΔΟΠΟΥΛΟΥ Cream Crackers Σίκαλης Ολικής 175 g — Σκλαβενίτης + mymarket· ήταν 425/9/68,7/11,5 (άγνωστη μάρκα) */
    'Φρυγανιά Σίκαλης Wasa': { kcal:336, p:9.0,  c:62.0, f:1.5,  role:'carb', min:11, max:55, piece:11, gi:'mid' }, /* 5/9/2026 brief 02 Θ (owner ναι): WASA Original 275 g (~24 τεμ) — Σκλαβενίτης + OFF 7300400481571 (3η πηγή: ετικέτα εκκρεμεί) */
    'Χουρμάδες':             { kcal:273, p:1.0,  c:75.6, f:0,    role:'carb', min:8,  max:60, fast:true, piece:7, gi:'fast' },
    'Μπανάνα':               { kcal:93,  p:0.8,  c:20.2, f:0,    role:'carb', min:60, ideal:180, max:240, fast:true, piece:118, gi:'mid' }, /* 6/9 (owner B7): φρούτο ιδανικό 1,5 τεμ. */
    'Μήλο':                  { kcal:61,  p:0.4,  c:14.8, f:0.2,  role:'carb', min:90, ideal:270, max:360, fast:true, piece:182, gi:'slow' }, /* 6/9 (owner B7): 1,5 τεμ. */
    'Μέλι':                  { kcal:302, p:0,    c:86.4, f:0,    role:'carb', min:5,  ideal:20, max:40, fast:true, piece:21, gi:'fast' }, /* 6/9 (owner B6): μέλι = γεύση ~20 g, ο υπόλοιπος υδατάνθρακας σε χορταστικές τροφές */
    /* 11/9/2026 (owner, Ερευνητής 14 — τροφές χρονισμού)· gi = κατάταξη Γ20.1 του 13 (slow ≤55 / mid 56-69 / fast ≥70), ΔΕΔΟΜΕΝΟ για τον ζυγό, ο solver ΔΕΝ το χρησιμοποιεί */
    'Ακτινίδιο':             { kcal:60,  p:1.0,  c:11.2, f:0.6,  role:'carb', min:70, ideal:140, max:210, fast:true, gi:'mid', piece:69 },  /* USDA 168153 + Ciqual 13021 + Swiss 395 (≤5,9 %)· 1 τεμ. 69 g· GI «μέτριο» (owner) */
    'Φράουλες':              { kcal:34,  p:0.6,  c:6.0,  f:0.4,  role:'carb', min:50, ideal:150, max:300, fast:true, gi:'slow', piece:18 }, /* 02+14: USDA 167762 + CoFID 14-324 + Swiss 385 (κανόνας ε)· 1 μεγάλη 18 g· GI 40 */
    /* §9.6.1 (owner 5/9/2026): ideal = μερίδα ανά γεύμα· τα λιπαρά μοιράζονται στα γεύματα (γύρω-γύρω έως το ideal), το λάδι «δανείζεται» από τα καρύδια */
    'Ελαιόλαδο':             { kcal:900, p:0,    c:0,    f:100, role:'fat', min:5,  ideal:20, max:40, explicit:true, piece:13.5 },
    'Καρύδια':               { kcal:734, p:17.2, c:15.5, f:73.6, role:'fat', min:5,  ideal:30, max:50, piece:4, autoAdd:1 },
    'Αμύγδαλα':              { kcal:657, p:22.0, c:19.0, f:53.0, role:'fat', min:5,  ideal:30, max:50, piece:1.2, autoAdd:2 },
    'Φυστικοβούτυρο':        { kcal:608, p:23.0, c:14.7, f:48.5, role:'fat', min:5,  ideal:30, max:50, piece:16 },
    'Αυγά Κρόκος':           { kcal:328, p:16.2, c:1.02, f:28.8, role:'fat', min:17, max:34, dayCap:34, piece:17 },
    'Σπόροι Τσία':           { kcal:447, p:19.0, c:9.6,  f:30.0, role:'fat', min:5,  ideal:15, max:30, piece:12 }, /* 10/9/2026 ετικέτα owner BIO VITA (2 πηγές: ετικέτα + ΑΒ)· ίνες 30 χωριστά, κορεσμένα 3,6· USDA 486/16,5/7,7/30,7 — ήταν 500/16,7/33,3/33,3 (ίνες μέσα στους Υ) */
    'Αβοκάντο':              { kcal:160, p:2.0,  c:1.8,  f:14.7, role:'fat', min:30, ideal:100, max:150, piece:100 },
    'Κασιους':               { kcal:595, p:18.0, c:26.9, f:44.0, role:'fat', min:5,  ideal:30, max:50, piece:1.5 }, /* 07: FNDDS 2707494 */
    'Κουκουνάρι':            { kcal:727, p:14.0, c:9.4, f:68.0, role:'fat', min:5,  ideal:15, max:30, piece:8.5 },
    'Σπόροι Κακάο':          { kcal:583, p:12.8, c:35.1, f:43.5, role:'fat', min:5,  ideal:15, max:30, piece:10 },
    /* 10/9/2026 (owner, γύρος 19 — Ερευνητής τροφών 11 γύρος 2, ετικέτες ΑΒ + φυσικές ετικέτες owner, ίνες εκτός §8.1.1) */
    'Ταχίνι':                { kcal:659, p:26.9, c:1.9,  f:58.2, role:'fat', min:5,  ideal:20, max:40, piece:15 }, /* ΜΑΚΕΔΟΝΙΚΟ Χαΐτογλου 300 g (ΑΒ 7080760, εκδοχή Α = βάζο owner)· ίνες 10 */
    'Ελιές Πράσινες':        { kcal:141, p:1.1,  c:1.0,  f:14.0, role:'fat', min:20, ideal:40, max:80, piece:2.7 }, /* XENIA χωρίς κουκούτσι −40 % αλάτι 130 g (ΑΒ 7624342, EAN 5201216133598)· ετικέτα owner §8.1.1· αλάτι 2,5· piece USDA 169096 «1 olive» */
    'Φιστίκια':              { kcal:614, p:20.0, c:16.4, f:45.0, role:'fat', min:5,  ideal:30, max:50, piece:0.7 }, /* EMMA ωμά χωρίς κέλυφος 150 g (ΑΒ 7640498, OFF 8590421075852)· Υ = 27 ολικοί − 10,6 ίνες USDA· ΟΧΙ Αιγίνης (εισαγωγής) */
    'Φουντούκια':            { kcal:672, p:14.0, c:11.0, f:62.0, role:'fat', min:5,  ideal:30, max:50, piece:1.4 }, /* EMMA ψίχα ωμά 200 g (ΑΒ 7640602)· ετικέτα owner §8.1.1· Υ ετικέτας (ίνες δεν δηλώνονται)· piece USDA 170581 «10 nuts = 14 g» */
    'Λιναρόσπορος':          { kcal:534, p:18.0, c:2.0,  f:42.0, role:'fat', min:5,  ideal:15, max:15, piece:7 },   /* ΟΛΑ BIO κοπανιστός 350 g (ΑΒ 7761360, OFF 5204217907014)· Υ = 29 − 27 ίνες· max 15/γεύμα (BfR)· ημερήσιο ταβάνι: session υγείας */
    'Μπρόκολο':              { kcal:29,  p:3.1,  c:5.4,  f:0.3,  role:'veg', min:50, max:400, piece:31 },
    'Ντοματίνια':            { kcal:18,  p:0.9,  c:2.7,  f:0.2,  role:'veg', min:50, max:300, piece:17 },
    'Αγγούρι':               { kcal:15,  p:1.0,  c:1.2,  f:0.6,  role:'veg', min:50, max:300, piece:301 },
    'Μανιτάρια White':       { kcal:25,  p:3.0,  c:3.0,  f:0,    role:'veg', min:50, max:300, piece:18 },
    'Πιπεριά Κόκκινη':       { kcal:26,  p:0.8,  c:3.9,  f:0,    role:'veg', min:50, max:300, piece:119 },
    'Πιπεριά Πράσινη':       { kcal:20,  p:0.9,    c:2.9,  f:0.2,  role:'veg', min:50, max:300, piece:119 },
    'Κρεμμύδι Ξερό':         { kcal:38,  p:0.8,  c:8.4,  f:0,    role:'veg', min:20, max:150, piece:110 },
    'Λαχανάκι Βρυξελών':     { kcal:43,  p:3.3,  c:5.2,  f:0.3,  role:'veg', min:50, max:300, piece:19 },
    'Καρότο':                { kcal:35,  p:0.9,  c:6.8,  f:0.2,  role:'veg', min:50, max:300, piece:61 },
    'Πατζάρι':               { kcal:36,  p:1.7,  c:7.6,  f:0.1,  role:'veg', min:50, max:300, piece:82 },
    'Baby Corn':             { kcal:60,  p:2.0,  c:11.2, f:0.8,  role:'veg', min:50, max:300 },
    'Τζίντζερ':              { kcal:80,  p:1.8,  c:15.8, f:0.7,  role:'veg', min:5,  max:30, piece:2 },
    'Ρόκα':                  { kcal:34,  p:2.6,  c:2.1,  f:0.7,  role:'veg', min:20, max:30, piece:100, exact:true },  /* 11/9/2026 (owner, 14): ετικέτα ΑΒ 7145106 φρέσκια σακούλα· Υ = σάκχαρα 2,1· «20-30 g για γεύση» — απλά όρια (το ιδανικό ανά λαχανικό εκκρεμεί στον ζυγό)· piece = σακουλάκι 100 g */
    'Σπανάκι':               { kcal:34,  p:2.9,  c:1.4,  f:0.4,  role:'veg', min:50, max:300, piece:100, exact:true }, /* 11/9/2026 (owner, 14): ΠΕΡΙΒΟΛΙ ΒΕΖΥΡΟΓΛΟΥ baby 100 g, ΑΒ 7811665 (§8.1.1)· Υ = 3,6 − 2,2 ίνες· ΚΛΑΣΙΚΑ */
    'Πέστο':                 { kcal:482, p:4.7,  c:9.8,  f:46.0, role:'extra', min:10, max:40, piece:16 },
    'Siracha Mayo':          { kcal:465, p:11.0, c:0.5,  f:46.0, role:'extra', min:5,  max:30, piece:14 }, /* = GO-TAN 215 ml· brief 02 Θ: η ετικέτα (4 πηγές) δίνει Π 0,5 / Υ 11 — ΕΚΚΡΕΜΕΙ ναι/όχι owner για τη διόρθωση */
    'Sriracha Mayo Flying Goose': { kcal:281, p:0.9, c:26.0, f:19.0, role:'extra', min:5, max:30, piece:14 }, /* 5/9/2026 brief 02 Θ (owner ναι): Flying Goose, vegan, ανά 100 ml — κατασκευαστής + OFF 8853662056661 (3η πηγή: ετικέτα εκκρεμεί) */
    'Teriyaki':              { kcal:100, p:6.4,  c:12.0, f:0,    role:'extra', min:10, max:50, piece:18 },
    'Κρεμα Γάλακτος Light':  { kcal:74,  p:3.3,  c:7.1,  f:3.5,  role:'extra', min:20, max:100, piece:15 }, /* = ΝΟΥΝΟΥ télia 3% (nounou.gr, ανά 100 ml: 74/3,3/7,1/3,5 — ταυτίζεται, 5/9/2026) */
    'Ψύλλιο Husk':           { kcal:194, p:2.6,  c:0.2,  f:1.1,  role:'extra', min:5,  max:15, piece:5 },
    'Kinder Σοκολατάκια':    { kcal:566, p:8.7,  c:53.5, f:35.0, role:'extra', min:13, max:38, piece:12.5, exact:true },
    /* 5/9/2026 brief 02 (Α16, owner ναι): snack ατομικής συσκευασίας, exact, TREATS στη ροή */
    'Kinder Bueno':          { kcal:572, p:8.6,  c:49.5, f:37.3, role:'extra', min:21.5, max:43, piece:21.5, exact:true },
    'Kinder Bueno White':    { kcal:571, p:8.6,  c:53.0, f:35.9, role:'extra', min:19.5, max:39, piece:19.5, exact:true },
    'Bounty':                { kcal:487, p:3.7,  c:59.0, f:26.0, role:'extra', min:28.5, max:57, piece:28.5, exact:true },
    'Σοκολάτα Υγείας 70%':   { kcal:535, p:8.9,  c:32.0, f:37.5, role:'extra', min:11, max:33, piece:11, exact:true }, /* 10/9/2026 (owner): ΠΑΥΛΙΔΗΣ 70 % 100 g (ΑΒ 7067905, EAN 7622300464349)· ζάχαρη 26· 1 ράβδος 11 g, 1-3 ράβδοι· «Κάτι για την ψυχή», ΟΧΙ λιπαρό */
    'Ninja Ice Cream':       { kcal:325.5, p:31.0, c:14.2, f:17.1, role:'container' },
    'Κεφίρ':                 { kcal:138,   p:8.8,  c:7.6,  f:8.0,  role:'container' }, /* = ΜΕΒΓΑΛ Κεφίρ Κατσικίσιο 200 ml (69/4,4/3,8/4 ανά 100 ml ×2 — ταυτίζεται, owner 5/9/2026, brief 02 Θ) */
    'Τσιπς Ρυζιού':          { kcal:124,   p:3.7,  c:22.0, f:1.9,  role:'container', gi:'fast' },
    'Layered':               { kcal:211,   p:20.0, c:20.0, f:6.1,  role:'container', piece:60, exact:true, gi:'mid' },
    /* 4/9/2026 (χρήστης, xlsx): bagel ανά τεμάχιο — container υδατάνθρακα (carbUnit: μπαίνει στην ομάδα υδατανθράκων, όχι πρωτεΐνης) */
    'Bagel':                 { kcal:214,   p:8.0,  c:40.0, f:2.0,  role:'container', carbUnit:true, piece:85, gi:'fast' },
    'Χυμός Παντζαριού Shot': { kcal:58,    p:2.0,  c:11.9, f:0.1,  role:'container', carbUnit:true, piece:70, exact:true } /* 11/9/2026 (owner, 14): Beet It Sport Nitrate 400, 70 ml (EAN 5020934007024)· 83/2,9/17/0,1 ανά 100 ml ×0,7· τεμάχιο κλειδωμένο· NOTE «1 την ημέρα, μέρες προπόνησης, πριν την προπόνηση» — ΧΩΡΙΣ κανόνα στον solver (ζυγός) */
  };

  /* gi: 'slow' | 'mid' | 'fast' (11/9/2026, 13 Γ20.1) — ΔΕΔΟΜΕΝΟ μόνο, ο solver δεν το διαβάζει ακόμη (ζυγός) */
  var R = Math.round;
  var WHEY_HARD_CAP = 90;
  var VEG_IDEAL = 150, VEG_MEAL_CAP = 250; /* 6/9/2026 (owner B4): λαχανικά σε πραγματική μερίδα στα κύρια γεύματα */
  function isMainMeal(m) { return !!m.main || /μεσημεριαν|βραδιν|κύριο|κυριο/i.test(m.name || ''); }
  var YOLK_DAY_CAP = 34; /* §9.6: 2 κρόκοι/ημέρα — κοινό για «Αυγά Κρόκος» και «Αυγό Ολόκληρο» (yolkEq, 5/9/2026 Α6) */
  function yolkOf(it) { var fd = fdOf(it); return (it.grams || 0) * (it.name === 'Αυγά Κρόκος' ? 1 : (fd.yolkEq || 0)); }
  function dayYolkEq(meals) { var y = 0; meals.forEach(function (m) { m.foods.forEach(function (it) { y += yolkOf(it); }); }); return y; } /* §9.7.1 (03/09/2026): η εξαίρεση της §9.7 δεν ξεπερνά ποτέ τα 90g/γεύμα */
  function per100(food, grams) {
    return { kcal: food.kcal * grams / 100, p: food.p * grams / 100, c: food.c * grams / 100, f: food.f * grams / 100 };
  }
  function foodMin(fd, sex) {
    if (fd.min != null) return fd.min;
    return (sex === 'm' ? fd.minM : fd.minF) || 0; /* §9.13 φακές/όσπρια */
  }
  function mealHasRealMain(m) {
    return m.foods.some(function (o) { return FOODS[o.name].role === 'main'; });
  }
  /* Κύρια στο πλαίσιο του γεύματος: main πάντα, tier2 μόνο χωρίς άλλη κύρια (§9.14) */
  function actsAsMain(it, m) {
    var fd = fdOf(it);
    if (fd.role === 'main') return true;
    if (fd.role === 'tier2') return !mealHasRealMain(m);
    return false;
  }

  /* ---------- Συνολικά γεύματος/ημέρας ---------- */
  function mealTotals(m) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    m.foods.forEach(function (it) {
      var fd = fdOf(it);
      var v = fd.role === 'container'
        ? { kcal: fd.kcal * (it.units || 1), p: fd.p * (it.units || 1), c: fd.c * (it.units || 1), f: fd.f * (it.units || 1) }
        : per100(fd, it.grams || 0);
      t.kcal += v.kcal; t.p += v.p; t.c += v.c; t.f += v.f;
    });
    return t;
  }
  function dayTotals(meals) {
    var t = { kcal: 0, p: 0, c: 0, f: 0 };
    meals.forEach(function (m) {
      var v = mealTotals(m);
      t.kcal += v.kcal; t.p += v.p; t.c += v.c; t.f += v.f;
    });
    return t;
  }


  /* Π1 (owner 5/9/2026, 00-plaisio Α10): όσπριο ΜΑΖΙ με κρέας/ψάρι στο ίδιο γεύμα = συνοδευτικό (υδατάνθρακας με πρωτεΐνη,
     40-120 g ωμό), όχι δεύτερη κύρια. Το item παίρνει it.side=true και ο solver το βλέπει με ρόλο carb. Χωρίς κρέας/ψάρι, το όσπριο
     παραμένει κύρια με τα όρια της §9.13. Ποτέ δύο όσπρια, ποτέ δύο κρέατα/ψάρια. */
  var SIDE_FD = {};
  function fdOf(it) {
    var fd = FOODS[it.name];
    if (!it.side || !fd || !fd.legume) return fd;
    if (!SIDE_FD[it.name]) { var c = {}; for (var k in fd) c[k] = fd[k]; c.role = 'carb'; c.min = 40; c.max = 120; delete c.minM; delete c.minF; c.side = true; SIDE_FD[it.name] = c; }
    return SIDE_FD[it.name];
  }
  function markSides(meals) {
    meals.forEach(function (m) {
      var meat = m.foods.some(function (x) { var f = FOODS[x.name]; return f && f.role === 'main' && !f.legume; });
      m.foods.forEach(function (x) { var f = FOODS[x.name]; if (f && f.legume) x.side = !!meat; });
    });
  }
  /* ---------- §9.9 Ισοκατανομή πρωτεΐνης — v3 «ΚΛΕΙΔΩΜΕΝΑ ΠΡΩΤΑ» (απόφαση owner 8/9/2026, σχέδιο docs/research/10-solver-v3-spec.md Β.1) ----------
     Ευέλικτη πρωτεϊνική τροφή = main/tier2/secondary που ΔΕΝ είναι locked ούτε container.
     Κλειδωμένο γεύμα = έχει κλειδωμένη πηγή (τόνος 112/224, σολομός 125/250, container) ΚΑΙ καμία ευέλικτη πρωτεϊνική τροφή
       (Τόνος 224 + Πατάτα + Ντοματίνια · Ninja μόνο · Σολομός + Ρύζι + Μπρόκολο). Γεύμα «Τόνος 112 + Φέτα + Τοστ» είναι ΕΥΕΛΙΚΤΟ: η φέτα κλείνει τη διαφορά.
     Δεσμευμένη πρωτεΐνη = ΟΛΗ η πρωτεΐνη των κλειδωμένων γευμάτων (κλειδωμένες τροφές + παθητική υδατανθράκων/λαχανικών στα τρέχοντα γραμμάρια)
       + η πρωτεΐνη κλειδωμένων τροφών ΜΕΣΑ σε ευέλικτα γεύματα.
     Target/ευέλικτο γεύμα = (στόχος − δεσμευμένη) / ευέλικτα γεύματα. Ξαναϋπολογίζεται σε κάθε iteration (η παθητική αλλάζει με τους υδατάνθρακες).
     Το κλειδωμένο γεύμα δεν έχει target· η επιλογή 112/224 · 125/250 ζυγίζει στο σκορ της ημέρας (solveDay) πόσο απέχει από το μερίδιό του (στόχος / όλα τα γεύματα, ±15). */
  function isFlexProteinFood(it) { var fd = fdOf(it); return !fd.locked && fd.role !== 'container' && (fd.role === 'main' || fd.role === 'tier2' || fd.role === 'secondary'); }
  function allocateProtein(targetProtein, meals, sex) {
    var minPerMeal = sex === 'm' ? 30 : 20;
    var fixedP = 0, flexMeals = [], lockedMeals = [];
    meals.forEach(function (m) {
      m.lockedP = 0;
      var hasLockedSrc = false;
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role === 'container') { m.lockedP += fd.p * (it.units || 1); hasLockedSrc = true; }
        if (fd.locked) { it.grams = it.grams || fd.locked[0]; m.lockedP += fd.p * it.grams / 100; hasLockedSrc = true; }
      });
      m.lockedMeal = hasLockedSrc && !m.foods.some(isFlexProteinFood);
      if (m.lockedMeal) { fixedP += mealTotals(m).p; m.pTarget = null; m.pTol = 15; m.hasMain = true; m.pCapped = false; lockedMeals.push(m); }
      else { fixedP += m.lockedP; flexMeals.push(m); }
    });
    var flexP = targetProtein - fixedP;
    var target = flexMeals.length ? flexP / flexMeals.length : 0;
    flexMeals.forEach(function (m) {
      m.hasMain = m.foods.some(function (it) { return actsAsMain(it, m); }); /* 6/9 (Δοκιμαστής #8): και ο κλειδωμένος σολομός είναι κύρια → ±15, όχι ±5 */
      m.pTarget = target;
      m.pTol = m.hasMain ? 15 : 5;
      m.pMin = minPerMeal;
      m.pCapped = false;
    });
    /* §9.9 (owner 06/09/2026, απόφαση 1α): γεύμα του οποίου η ΜΟΝΗ πηγή πρωτεΐνης είναι whey (Post-Workout shake) χωρά το πολύ
       45 g × 90 % = 40,5 g. Όταν ο στόχος/γεύμα είναι πάνω από αυτό, το γεύμα ΔΕΝ είναι ανισοκατανομή: ο στόχος του γίνεται
       η χωρητικότητά του και η διαφορά μοιράζεται στα υπόλοιπα ευέλικτα γεύματα. Ισχύει ΜΟΝΟ για το Post-Workout με whey ως μοναδική
       πηγή (Κ-Ζ δεν δέχεται 2η πηγή εκεί) — κάθε άλλο γεύμα, ακόμη και whey-only, συνεχίζει να παίρνει ενισχυτή με τη σκάλα §9.8.2. */
    var cappedP = 0, nCapped = 0;
    flexMeals.forEach(function (m) {
      var prot = m.foods.filter(isFlexProteinFood);
      if (!/post[- ]?workout/i.test(m.name)) return; /* μόνο το Post-Workout shake (Κ-Ζ: whey + γρήγορος υδατάνθρακας, χωρίς 2η πηγή) */
      if (!prot.length || !prot.every(function (it) { return fdOf(it).wheyCap; })) return;
      var capP = m.lockedP;
      prot.forEach(function (it) { capP += fdOf(it).p * 45 / 100; });
      if (capP < target - m.pTol) { m.pCapped = true; m.pTarget = capP; cappedP += capP; nCapped++; }
    });
    if (nCapped && flexMeals.length > nCapped) {
      var t2 = (flexP - cappedP) / (flexMeals.length - nCapped);
      flexMeals.forEach(function (m) { if (!m.pCapped) m.pTarget = t2; });
    }
    var share = targetProtein / Math.max(1, meals.length);
    lockedMeals.forEach(function (m) { m.pShare = share; });
    return { lockedP: fixedP, flexTarget: target, flexMeals: flexMeals, lockedMeals: lockedMeals, share: share };
  }

  /* ---------- Γέμισμα πρωτεΐνης σε γεύμα (§9.14 calibration) ---------- */
  function fillMealProtein(m, sex) {
    var got = m.lockedP;
    /* παθητική πρωτεΐνη από carb/fat/veg τροφές του τρέχοντος iteration */
    m.foods.forEach(function (it) {
      var fd = fdOf(it);
      if (fd.role === 'carb' || fd.role === 'fat' || fd.role === 'veg' || fd.role === 'extra') got += fd.p * (it.grams || 0) / 100;
    });
    var mains = [], secs = [];
    m.foods.forEach(function (it) {
      var fd = fdOf(it);
      if (fd.locked || fd.role === 'container') return;
      if (actsAsMain(it, m)) mains.push(it);
      else if (fd.role === 'secondary' || fd.role === 'tier2') secs.push(it);
    });
    /* κύρια στο εύλογο μέγιστο πρώτα (§9.14) */
    mains.forEach(function (it) {
      var fd = fdOf(it);
      var min = foodMin(fd, sex);
      var need = (m.pTarget - got) / (fd.p / 100);
      it.grams = Math.max(min, Math.min(fd.max, R(need)));
      got += fd.p * it.grams / 100;
    });
    /* 6/9/2026 (owner B5, §9.8.2 βήμα 0): οι δευτερεύουσες με ιδανικό (γιαούρτι 300, cottage 200, ασπράδι 200) γεμίζουν ΠΡΙΝ από τη whey */
    secs.sort(function (a, b) { return (fdOf(a).wheyCap ? 1 : 0) - (fdOf(b).wheyCap ? 1 : 0); });
    secs.forEach(function (it) {
      var fd = fdOf(it);
      var idealMax = fd.ideal || fd.max;
      var need = (m.pTarget - got) / (fd.p / 100);
      it.grams = Math.max(0, Math.min(idealMax, R(need)));
      if (it.grams > 0 && it.grams < fd.min) it.grams = fd.min;
      got += fd.p * it.grams / 100;
    });
    m.proteinGot = got;
  }

  /* ---------- Σκάλα προτεραιότητας πρωτεΐνης για global εξισορρόπηση ----------
     Άνοδος: 1 κύριες→max (§9.14) · 2 tier2-συμπλήρωμα→max · 3 δευτερεύουσες→ideal/max
     (whey→45 §9.7) · 4 γιαούρτι 300→450 (§9.8.1, μόνο αφού εξαντληθούν τα άλλα) ·
     5 whey πέραν των 45g (§9.7 εξαίρεση, με ρητό flag). Κάθοδος: αντίστροφα. */
  function proteinLadder(meals, sex) {
    var up = [], down = [];
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.locked || fd.role === 'container') return;
        var min = foodMin(fd, sex);
        if (actsAsMain(it, m)) {
          up.push({ it: it, fd: fd, m: m, tier: 1, cap: fd.max });
          down.push({ it: it, fd: fd, m: m, tier: 5, floor: min });
        } else if (fd.role === 'tier2') {
          up.push({ it: it, fd: fd, m: m, tier: 2, cap: fd.max });
          down.push({ it: it, fd: fd, m: m, tier: 4, floor: min });
        } else if (fd.role === 'secondary') {
          var idealCap = fd.wheyCap ? 45 : (fd.ideal || fd.max);
          if (fd.yolkEq) { var yolkRoom = Math.max(0, YOLK_DAY_CAP - (dayYolkEq(meals) - yolkOf(it))); idealCap = Math.min(idealCap, Math.floor(yolkRoom / fd.yolkEq)); }
          /* 6/9 (owner B5): whey ανεβαίνει ΜΕΤΑ τις άλλες δευτερεύουσες (3,5) και κατεβαίνει ΠΡΙΝ πέσουν εκείνες κάτω από το ιδανικό (2,5) */
          up.push({ it: it, fd: fd, m: m, tier: fd.wheyCap ? 3.5 : 3, cap: idealCap });
          down.push({ it: it, fd: fd, m: m, tier: fd.wheyCap ? 2.5 : 3, floor: 0, minIfUsed: minUseOf(it, fd) }); /* v3 Ζ.3: whey από συμπλήρωση ≥25 g */
          if (fd.ideal && fd.max > fd.ideal && !fd.yolkEq) {
            up.push({ it: it, fd: fd, m: m, tier: 4, cap: fd.max });
            down.push({ it: it, fd: fd, m: m, tier: 2, floor: fd.ideal });
          }
          if (fd.wheyCap) {
            up.push({ it: it, fd: fd, m: m, tier: 5, cap: WHEY_HARD_CAP, wheyException: true });
            down.push({ it: it, fd: fd, m: m, tier: 1, floor: 45 });
          }
        }
      });
    });
    up.sort(function (a, b) { return a.tier - b.tier; });
    down.sort(function (a, b) { return a.tier - b.tier; });
    return { up: up, down: down };
  }

  /* §9.9 (5/9/2026): η εξισορρόπηση ημέρας γίνεται σε ΔΥΟ περάσματα. Πέρασμα 1: κάθε γεύμα μένει μέσα στην ανοχή του
     (target ±15 g με κύρια, ±5 g μόνο με δευτερεύουσες) — έτσι το πλεόνασμα δεν πέφτει όλο στο κύριο γεύμα (340 g γαρίδες)
     ούτε το έλλειμμα σε ένα γεύμα. Πέρασμα 2 (μόνο αν μένει διαφορά): χωρίς ανοχή, όπως πριν· η ανισοκατανομή
     αναφέρεται μετά ως issue `protein-uneven` (ρεαλισμός, όχι όριο §11) για να συμπληρωθεί με whey/τυρί (§9.8.2). */
  function mealRoomUp(m) { return (m.pTarget != null) ? (m.pTarget + m.pTol) - mealTotals(m).p : 0; }
  function mealFloorP(m, minPerMeal) { return (m.pTarget != null) ? Math.max(minPerMeal, m.pTarget - m.pTol) : minPerMeal; }
  function balanceProteinDay(meals, targets, sex, issues) {
    var ladder = proteinLadder(meals, sex);
    var guard = 0, minPerMeal = sex === 'm' ? 30 : 20;
    /* Άνοδος: έλλειμμα ημέρας */
    var diff = targets.p - dayTotals(meals).p;
    for (var pass = 0; pass < 2 && diff > 1; pass++) {
      for (var i = 0; i < ladder.up.length && diff > 1 && guard < 800; i++, guard++) {
        var c = ladder.up[i];
        var cur = c.it.grams || 0;
        if (cur >= c.cap) continue;
        var wantP = diff;
        if (pass === 0) { var roomP = mealRoomUp(c.m); if (roomP <= 0.5) continue; wantP = Math.min(diff, roomP); }
        var needG = Math.ceil(wantP / (c.fd.p / 100));
        var add = Math.min(needG, (c.cap === Infinity ? needG : c.cap - cur));
        var mu0 = minUseOf(c.it, c.fd);
        if (cur === 0 && mu0 && cur + add < mu0) { if (pass === 0 && mu0 * c.fd.p / 100 > roomP + 2) continue; add = mu0; }
        if (c.wheyException && cur + add > 45) {
          issues.push({ type: 'whey-exception', meal: c.m.name, grams: cur + add,
            note: '§9.7: υπέρβαση 45g whey — οι υπόλοιπες πηγές είναι στα λογικά maximums' });
          if (cur + add >= WHEY_HARD_CAP && diff - c.fd.p * add / 100 > 1) {
            issues.push({ type: 'whey-cap', meal: c.m.name, grams: WHEY_HARD_CAP,
              suggest: 'Η whey έφτασε το ταβάνι των ' + WHEY_HARD_CAP + 'g στο ' + c.m.name + ' (§9.7.1) — πρόσθεσε άλλη πηγή πρωτεΐνης στο γεύμα.' });
          }
        }
        c.it.grams = cur + add;
        diff -= c.fd.p * add / 100;
      }
    }
    /* Κάθοδος: πλεόνασμα ημέρας — πέρασμα 1 όχι κάτω από target−ανοχή, πέρασμα 2 όχι κάτω από το hard min §9.9
       (αλλιώς το enforceMealMinimums το ξαναγεμίζει και ο κύκλος δεν κλείνει) */
    diff = dayTotals(meals).p - targets.p;
    /* 6/9/2026 (§9.9): πέρασμα 0 της καθόδου — γεύματα ΠΑΝΩ από target+ανοχή κόβονται πρώτα (και οι κύριες τους), ώστε το πλεόνασμα
       από την παθητική πρωτεΐνη των υδατανθράκων να μη φεύγει από τη whey του πρωινού ενώ το κοτόπουλο του βραδινού μένει στα 380 g */
    for (var j0 = 0; j0 < ladder.down.length && diff > 1 && guard < 1600; j0++, guard++) {
      var d0 = ladder.down[j0], m0 = d0.m; if (m0.pTarget == null) continue;
      var overP = mealTotals(m0).p - (m0.pTarget + m0.pTol); if (overP <= 0.5) continue;
      var g0 = d0.it.grams || 0; if (g0 <= d0.floor) continue;
      var cut0 = Math.min(g0 - d0.floor, Math.ceil(Math.min(diff, overP) / (d0.fd.p / 100)));
      var ng0 = g0 - cut0; if (d0.minIfUsed && ng0 > 0 && ng0 < d0.minIfUsed) ng0 = d0.minIfUsed; if (ng0 < d0.floor) ng0 = d0.floor;
      diff -= d0.fd.p * (g0 - ng0) / 100; d0.it.grams = ng0;
    }
    for (var pass2 = 0; pass2 < 2 && diff > 1; pass2++) {
      for (var j = 0; j < ladder.down.length && diff > 1 && guard < 1600; j++, guard++) {
        var d = ladder.down[j];
        var g = d.it.grams || 0;
        if (g <= d.floor) continue;
        var mealRoomP = mealTotals(d.m).p - (pass2 === 0 ? mealFloorP(d.m, minPerMeal) : minPerMeal);
        if (mealRoomP <= 0) continue;
        var cutG = Math.min(g - d.floor,
          Math.ceil(Math.min(diff, mealRoomP) / (d.fd.p / 100)));
        var ng = g - cutG;
        /* 6/9: το μηδένισμα (κάτω από το min → 0) σέβεται το περιθώριο του γεύματος — αλλιώς το πέρασμα 1 παραβίαζε την ανοχή §9.9 (whey 21→0 = −19 g Π για πλεόνασμα 6) */
        if (d.minIfUsed && ng > 0 && ng < d.minIfUsed) ng = (g - d.minIfUsed >= 0 && Math.min(diff, mealRoomP) * 100 / d.fd.p > g - d.minIfUsed && d.fd.p * g / 100 <= mealRoomP + 0.5) ? 0 : d.minIfUsed;
        if (ng < d.floor) ng = d.floor;
        diff -= d.fd.p * (g - ng) / 100;
        d.it.grams = ng;
      }
    }
    transferProtein(meals, sex); /* Β.3 (v3): μεταφορά ανάμεσα σε γεύματα όταν το σύνολο βγαίνει αλλά ένα γεύμα είναι εκτός ανοχής */
  }

  /* ---------- Β.3 (v3, 9/9/2026): ΜΕΤΑΦΟΡΑ πρωτεΐνης ανάμεσα σε γεύματα ----------
     Όταν η ημέρα βγαίνει στο σύνολο αλλά ένα γεύμα είναι εκτός ανοχής, η πρωτεΐνη μετακινείται — ουδέτερα για την ημέρα (ΔP ≈ 0):
     · γεύμα που ΥΣΤΕΡΕΙ παίρνει από γεύματα πάνω από τον στόχο τους (ακόμη κι αν είναι μέσα στην ανοχή)· κανένα δεν πέφτει ΚΑΤΩ από τον στόχο του
     · γεύμα που ΠΕΡΙΣΣΕΥΕΙ δίνει σε γεύματα κάτω από τον στόχο τους· κανένα δεν ανεβαίνει ΠΑΝΩ από target+ανοχή
     Σκάλα καθόδου της πηγής: whey → δευτερεύουσες → τυρί → κύριες έως τα ελάχιστά τους (ΣΤ.2: η κύρια κόβεται τελευταία).
     Σκάλα ανόδου του δέκτη: κύρια → tier2 → δευτερεύουσες έως το ιδανικό → whey έως 45 (ΟΧΙ πέραν ιδανικού/45 — αυτά μένουν δηλωμένα βήματα).
     Κάθε βήμα γίνεται δεκτό ΜΟΝΟ αν J = Σ max(0, |dev| − ανοχή) μειώνεται ≥ 0,5 (αυστηρά φθίνουσα → τερματίζει, ΣΤ.1)· guard 200 βήματα.
     opt.kcalTarget: στο τελικό στάδιο (μετά τους υδατάνθρακες) το βήμα δεν γίνεται δεκτό αν βγάζει την ημέρα εκτός ±25 kcal. */
  function minUseOf(it, fd) { return it.minUse || fd.min || 0; }
  function transferProtein(meals, sex, opt) {
    opt = opt || {};
    var flex = meals.filter(function (m) { return m.pTarget != null; });
    if (flex.length < 2) return 0;
    var devOf = function (m) { return mealTotals(m).p - m.pTarget; };
    var viol = function (m) { var d = devOf(m); if (m.pCapped && d < 0) return 0; return Math.max(0, Math.abs(d) - m.pTol); };
    var J = function () { var s = 0; flex.forEach(function (m) { s += viol(m); }); return s; };
    var ladder = proteinLadder(meals, sex);
    var downOf = function (o) { for (var i = 0; i < ladder.down.length; i++) { var d = ladder.down[i]; if (d.m === o && (d.it.grams || 0) > d.floor + 0.01) return d; } return null; };
    var upOf = function (u) { for (var i = 0; i < ladder.up.length; i++) { var c = ladder.up[i]; if (c.m === u && c.tier < 4 && (c.it.grams || 0) < c.cap - 0.01) return c; } return null; };
    var moved = 0, guard = 0, skip = {};
    while (guard++ < 200) {
      var worst = null;
      flex.forEach(function (m) { if (viol(m) > 0.5 && (!worst || viol(m) > viol(worst))) worst = m; });
      if (!worst) break;
      var under = devOf(worst) < 0;
      var partners = flex.filter(function (m) { return m !== worst && (under ? devOf(m) > 0.5 : devOf(m) < -0.5) && !skip[worst.name + '|' + m.name]; })
        .sort(function (a, b) { return under ? devOf(b) - devOf(a) : devOf(a) - devOf(b); });
      var done = false;
      for (var pi = 0; pi < partners.length && !done; pi++) {
        var partner = partners[pi];
        var src = under ? partner : worst, dst = under ? worst : partner;
        var key = worst.name + '|' + partner.name;
        var cutC = downOf(src), upC = upOf(dst);
        if (!cutC || !upC) { skip[key] = 1; continue; }
        /* πόσο: το ελάχιστο που φέρνει τον «χειρότερο» μέσα (+1 g περιθώριο στρογγυλοποίησης), χωρίς ο src να πέσει κάτω από τον στόχο του
           ούτε ο dst να ανέβει πάνω από target+ανοχή */
        var need = under ? (-devOf(dst) - dst.pTol + 1) : (devOf(src) - src.pTol + 1);
        var uCur = upC.it.grams || 0, umu = minUseOf(upC.it, upC.fd), gCur = cutC.it.grams || 0;
        /* το βήμα περιορίζεται και από το περιθώριο της τροφής που κόβεται και της τροφής που ανεβαίνει — αν δεν φτάνει, γίνεται ΜΕΡΙΚΗ μεταφορά
           και ο βρόχος συνεχίζει με την επόμενη τροφή της σκάλας (π.χ. γιαούρτι 343→300 και μετά whey 45→30, ενώ η φέτα ανεβαίνει) */
        var giveP = Math.min(need, devOf(src), -devOf(dst) + dst.pTol, (gCur - cutC.floor) * cutC.fd.p / 100, (upC.cap - uCur) * upC.fd.p / 100);
        if (giveP <= 0.5) { skip[key] = 1; continue; }
        var addG = Math.min(upC.cap - uCur, Math.ceil(giveP / (upC.fd.p / 100)));
        if (uCur === 0 && upC.fd.min && addG < umu) { if (umu * upC.fd.p / 100 > -devOf(dst) + dst.pTol + 0.5 || umu * upC.fd.p / 100 > (gCur - cutC.floor) * cutC.fd.p / 100 + 1.5) { skip[key] = 1; continue; } addG = umu; }
        var addP = upC.fd.p * addG / 100;
        var cutG = Math.min(gCur - cutC.floor, Math.ceil(addP / (cutC.fd.p / 100)));
        var ng = gCur - cutG, cmu = minUseOf(cutC.it, cutC.fd);
        if (cutC.minIfUsed != null && ng > 0 && ng < cmu) ng = (cutC.fd.p * gCur / 100 <= addP + 1.5) ? 0 : cmu;
        if (ng < cutC.floor) ng = cutC.floor;
        var cutP = cutC.fd.p * (gCur - ng) / 100;
        if (cutP <= 0.5 || Math.abs(cutP - addP) > 1.5) { skip[key] = 1; continue; } /* όχι ουδέτερη μεταφορά — παράλειψη */
        var before = J();
        cutC.it.grams = ng; upC.it.grams = uCur + addG;
        var kcalOk = opt.kcalTarget == null || Math.abs(dayTotals(meals).kcal - opt.kcalTarget) <= 25;
        if (J() <= before - 0.5 && kcalOk) { moved++; done = true; }
        else { cutC.it.grams = gCur; upC.it.grams = uCur; skip[key] = 1; }
      }
      if (!done) break;
    }
    return moved;
  }

  /* Hard minimum πρωτεΐνης/γεύμα (§9.9): boost εντός γεύματος· αναφορά μόνο
     στο τέλος (report=true) ώστε τα νούμερα να είναι της τελικής κατάστασης */
  function enforceMealMinimums(meals, flexMeals, sex, issues, report) {
    var minPerMeal = sex === 'm' ? 30 : 20;
    flexMeals.forEach(function (m) {
      var t = mealTotals(m);
      if (t.p >= minPerMeal - 0.5) return;
      var lack = minPerMeal - t.p;
      m.foods.forEach(function (it) {
        if (lack <= 0) return;
        var fd = fdOf(it);
        if (fd.locked || fd.role === 'container') return;
        if (fd.role !== 'main' && fd.role !== 'tier2' && fd.role !== 'secondary') return;
        var cap = fd.wheyCap ? 45 : fd.max;
        var cur = it.grams || 0;
        if (cur >= cap) return;
        var add = Math.min(cap - cur, Math.ceil(lack / (fd.p / 100)));
        if (cur === 0 && fd.min && add < fd.min) add = fd.min;
        it.grams = cur + add;
        lack -= fd.p * add / 100;
      });
      var t2 = mealTotals(m);
      if (report && t2.p < minPerMeal - 0.5) {
        issues.push({ type: 'meal-under-min-protein', meal: m.name, got: R(t2.p), min: minPerMeal,
          suggest: 'Πρόσθεσε πρωτεϊνική τροφή στο γεύμα ή συγχώνευσέ το με άλλο (§9.9).' });
      }
    });
  }

  /* ---------- Λιπαρά §9.6: κρόκοι ≤30g/ημέρα → ελαιόλαδο → healthy fats (auto) ---------- */
  /* ---------- Λιπαρά §9.6 + §9.6.1 (owner 5/9/2026): μοιράζονται στα γεύματα, όχι σε ένα ----------
     Άνοδος: (0) κάθε λιπαρή τροφή του γεύματος παίρνει το min της (το λάδι «λαδώνει» το μπρόκολο) → (1) γύρω-γύρω έως το ideal,
     πάντα στο γεύμα με τα λιγότερα λιπαρά → (2) §9.6 auto-add καρύδια/αμύγδαλα σε γεύμα χωρίς λιπαρή τροφή (όχι Post) →
     (3) πέραν του ideal προς το max, γύρω-γύρω, με ορατή σήμανση `fat-over-ideal`.
     Κάθοδος: πρώτα ό,τι είναι πάνω από το ideal, μετά γύρω-γύρω προς το min από το γεύμα με τα περισσότερα λιπαρά (τα καρύδια «δανείζουν»
     στο λάδι), τα auto μηδενίζονται/αφαιρούνται, και μόνο στο τέλος (§9.4) explicit τροφές κάτω από το min → 0. */
  var AUTO_FAT_ORDER = ['Αμύγδαλα', 'Καρύδια', 'Φυστικοβούτυρο', 'Αβοκάντο', 'Κασιους', 'Σπόροι Τσία', 'Κουκουνάρι', 'Φιστίκια', 'Φουντούκια', 'Ταχίνι', 'Ελιές Πράσινες', 'Λιναρόσπορος']; /* 6/9 (owner B8)· 10/9: +5 νέες λιπαρές (η σοκολάτα είναι extra, ποτέ εδώ) */
  function solveFats(meals, fatTarget, issues, autoFats) {
    var STEP = 5;
    /* 6/9/2026 (owner B8, §9.6): η αυτόματη συμπλήρωση διαλέγει από τις τροφές που ΤΣΕΚΑΡΕ ο χρήστης (autoFats)· λάδι μόνο σε κύριο γεύμα·
       χωρίς autoFats (δρόμος γεύμα-γεύμα) μένει Καρύδια → Αμύγδαλα όπως πριν. */
    var pool = (autoFats || []).filter(function (n) { return FOODS[n] && FOODS[n].role === 'fat' && n !== 'Αυγά Κρόκος'; });
    var autoFor = function (m) {
      if (!pool.length) return 'Καρύδια';
      if (isMainMeal(m) && pool.indexOf('Ελαιόλαδο') >= 0) return 'Ελαιόλαδο';
      for (var q = 0; q < AUTO_FAT_ORDER.length; q++) if (pool.indexOf(AUTO_FAT_ORDER[q]) >= 0) return AUTO_FAT_ORDER[q];
      return pool.indexOf('Ελαιόλαδο') >= 0 && isMainMeal(m) ? 'Ελαιόλαδο' : null;
    };
    var fatItems = [];
    meals.forEach(function (m) { m.foods.forEach(function (it) { if (fdOf(it).role === 'fat') fatItems.push({ it: it, fd: fdOf(it), m: m }); }); });
    var isPost = function (m) { return /post[- ]?workout/i.test(m.name); };
    var idealOf = function (x) { return x.fd.ideal || x.fd.max; };
    var room = function (x) {
      var r = x.fd.max - (x.it.grams || 0);
      if (x.it.name === 'Αυγά Κρόκος') r = Math.min(r, YOLK_DAY_CAP - dayYolkEq(meals));
      return Math.max(0, r);
    };
    var deficit = fatTarget - dayTotals(meals).f, guard = 0;
    if (deficit > 3) {
      fatItems.forEach(function (x) {
        if (deficit <= 3) return;
        var g = x.it.grams || 0;
        if (g < x.fd.min) { var add0 = Math.min(x.fd.min - g, room(x)); if (add0 > 0) { x.it.grams = g + add0; deficit -= x.fd.f * add0 / 100; } }
      });
      while (deficit > 3 && guard++ < 400) {
        var cands = fatItems.filter(function (x) { return (x.it.grams || 0) < idealOf(x) && room(x) > 0; });
        if (!cands.length) break;
        cands.sort(function (a, b) { return mealTotals(a.m).f - mealTotals(b.m).f; });
        var x1 = cands[0], g1 = x1.it.grams || 0;
        var add1 = Math.min(STEP, idealOf(x1) - g1, room(x1), Math.ceil(deficit / (x1.fd.f / 100)));
        if (add1 <= 0) break;
        x1.it.grams = g1 + add1; deficit -= x1.fd.f * add1 / 100;
      }
      var autoPasses = pool.length ? [autoFor] : [function () { return 'Καρύδια'; }, function () { return 'Αμύγδαλα'; }];
      autoPasses.forEach(function (pick) {
        if (deficit <= 3) return;
        meals.forEach(function (m) {
          if (deficit <= 3 || isPost(m)) return;
          if (m.foods.some(function (x) { return fdOf(x).role === 'fat'; })) return;
          if (m.foods.every(function (x) { return fdOf(x).role === 'container'; })) return;
          var name = pick(m); if (!name) return;
          var fd = FOODS[name];
          var addG = Math.min(fd.ideal || fd.max, Math.max(10, fd.min, Math.ceil(deficit / (fd.f / 100)))); /* Ζ.3 (owner 9/9/2026): ελάχιστη ουσιαστική προσθήκη λιπαρού 10 g */
          var it = { name: name, grams: addG, auto: true };
          m.foods.push(it); fatItems.push({ it: it, fd: fd, m: m });
          deficit -= fd.f * addG / 100;
          issues.push({ type: 'auto-fat-added', meal: m.name, food: name, grams: addG, note: '§9.6: αυτόματη συμπλήρωση λιπαρών από τις τροφές του χρήστη' });
        });
      });
      guard = 0;
      while (deficit > 3 && guard++ < 400) {
        var c3 = fatItems.filter(function (x) { return room(x) > 0; });
        if (!c3.length) break;
        c3.sort(function (a, b) { return (a.it.grams || 0) / idealOf(a) - (b.it.grams || 0) / idealOf(b); });
        var x3 = c3[0], g3 = x3.it.grams || 0;
        var add3 = Math.min(STEP, room(x3), Math.ceil(deficit / (x3.fd.f / 100)));
        if (add3 <= 0) break;
        x3.it.grams = g3 + add3; deficit -= x3.fd.f * add3 / 100;
      }
    } else if (deficit < -3) {
      var over = -deficit;
      var removeIf0 = function (z) { if ((z.it.grams || 0) === 0 && z.it.auto) { var i1 = z.m.foods.indexOf(z.it); if (i1 >= 0) z.m.foods.splice(i1, 1); fatItems.splice(fatItems.indexOf(z), 1); } };
      guard = 0;
      while (over > 3 && guard++ < 600) {
        var above = fatItems.filter(function (x) { return (x.it.grams || 0) > idealOf(x); });
        var pool = above.length ? above : fatItems.filter(function (x) { return (x.it.grams || 0) > (x.it.auto ? 0 : x.fd.min); });
        if (!pool.length) break;
        pool.sort(function (a, b) { return mealTotals(b.m).f - mealTotals(a.m).f; });
        var z = pool[0], gz = z.it.grams || 0, floor = above.length ? idealOf(z) : (z.it.auto ? 0 : z.fd.min);
        var cut = Math.min(STEP, gz - floor, Math.ceil(over / (z.fd.f / 100)));
        if (cut <= 0) break;
        var ng = gz - cut; if (z.it.auto && ng > 0 && ng < z.fd.min) ng = 0;
        over -= z.fd.f * (gz - ng) / 100; z.it.grams = ng; removeIf0(z);
      }
      /* §9.4: αν ακόμη περισσεύουν λιπαρά, explicit τροφές (λάδι) μηδενίζονται — ορίζονται για να βγουν τα macros */
      var order4 = ['Σπόροι Τσία', 'Κουκουνάρι', 'Κασιους', 'Αβοκάντο', 'Φυστικοβούτυρο', 'Αμύγδαλα', 'Καρύδια', 'Ελαιόλαδο', 'Αυγά Κρόκος'];
      order4.forEach(function (name) {
        if (over <= 3) return;
        fatItems.slice().forEach(function (z) {
          if (over <= 3 || z.it.name !== name) return;
          var g = z.it.grams || 0; if (g <= 0) return;
          var cutG = Math.min(g, Math.ceil(over / (z.fd.f / 100)));
          var ng2 = g - cutG; if (ng2 > 0 && ng2 < z.fd.min) ng2 = 0;
          over -= z.fd.f * (g - ng2) / 100; z.it.grams = ng2; removeIf0(z);
        });
      });
    }
  }

  /* ---------- Υδατάνθρακες (§7.3 residual + §9.15 windows) ---------- */
  function windowOf(m, idx) {
    var n = m.name || '';
    if (/post[- ]?workout/i.test(n)) return 'post';
    if (/pre[- ]?workout/i.test(n)) return 'pre';
    if (/κύριο|μετά/i.test(n)) return 'main';
    if (idx === 0) return 'breakfast';
    return 'rest';
  }

  function solveCarbs(meals, dayType, targets, sex, issues, tuneOnly) {
    /* tuneOnly=false: πλήρης κατασκευή (μηδενισμός, post, παράθυρα, fine-tune).
       tuneOnly=true: μόνο αυξητική διόρθωση kcal πάνω στην υπάρχουσα κατάσταση —
       έτσι το iteration συγκλίνει αντί να ταλαντώνεται. */
    var items = [];
    meals.forEach(function (m, i) {
      var nCarb = 0;
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role !== 'carb') return;
        if (!tuneOnly) it.grams = 0;
        /* 8/9/2026 (Δοκιμαστής γ2 #16, owner B7): ο 2ος/3ος υδατάνθρακας του γεύματος μένει έως το ιδανικό του (ψωμί/τορτίγια/κράκερς χωρίς ιδανικό: 50 g) —
           όχι 120 g τοστ δίπλα σε 400 g πατάτα· αν πάλι λείπουν kcal, δηλώνεται. Ο πρώτος υδατάνθρακας της λίστας είναι ο κύριος. */
        items.push({ it: it, fd: fd, m: m, win: dayType === 'workout' ? windowOf(m, i) : 'flat', second: nCarb > 0 && !/post[- ]?workout/i.test(m.name) });
        nCarb++;
      });
    });
    if (!items.length) return;

    if (dayType === 'workout') {
      var hasTiming = meals.some(function (m) { return /pre[- ]?workout|post[- ]?workout/i.test(m.name); });
      if (!hasTiming) {
        /* §9.15 trigger: χωρίς Pre/Post ονόματα ο κανόνας δεν εφαρμόζεται — ρώτα τον χρήστη */
        if (!tuneOnly) issues.push({ type: 'timing-unclear',
          note: '§9.15: τα ονόματα γευμάτων δεν δηλώνουν Pre/Post-Workout — ζητείται διευκρίνιση, εφαρμόζεται ισοκατανομή' });
        items.forEach(function (x) { x.win = 'flat'; });
      }
    }

    var flexG;
    if (tuneOnly) {
      flexG = 1;
      items.forEach(function (x) { flexG += x.fd.c * (x.it.grams || 0) / 100; });
    } else {
      var residual = targets.kcal - dayTotals(meals).kcal;
      if (residual <= 0) return; /* δεν χωράνε υδατάνθρακες — θα φανεί στον έλεγχο §11 */
      flexG = residual / 4;
    }

    /* Πίεση πρωτεΐνης: αν οι πρωτεϊνικές τροφές δεν έχουν περιθώριο να «απορροφήσουν»
       την παθητική πρωτεΐνη των carbs (trim στο επόμενο iteration), προτίμησε τροφές
       φτωχές σε πρωτεΐνη (πατάτα/ρύζι/φρούτα αντί βρώμης) ώστε να μην ξεφύγει ο στόχος */
    var trimCap = 0;
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.locked || fd.role === 'container') return;
        if (fd.role !== 'main' && fd.role !== 'tier2' && fd.role !== 'secondary') return;
        var floor = (fd.role === 'secondary') ? 0 : foodMin(fd, sex);
        trimCap += Math.max(0, (it.grams || 0) - floor) * fd.p / 100;
      });
    });
    /* Σκληρός προϋπολογισμός: πρωτεΐνη που επιτρέπεται να προσθέσουν συνολικά τα carbs =
       όσα μπορούν να επιστρέψουν οι πρωτεϊνικές τροφές (trim) + τρέχον έλλειμμα + ανοχή.
       Στο tune-only mode ΜΟΝΟ το έλλειμμα — αλλιώς ο tuner χαλάει την εξισορρόπηση. */
    var pBudget = (tuneOnly ? 0 : trimCap) + Math.max(0, targets.p - dayTotals(meals).p) + 2;
    var proteinTight = pBudget < flexG * 0.12;
    var byPDensity = function (a, b) { return (a.fd.p / a.fd.kcal) - (b.fd.p / b.fd.kcal); };
    var carbPNow = function () {
      var s = 0;
      items.forEach(function (x) { s += x.fd.p * (x.it.grams || 0) / 100; });
      return s;
    };
    var carbP0 = carbPNow(); /* baseline: το budget αφορά μόνο τη ΜΕΤΑΒΟΛΗ */
    /* 6/9/2026 (owner B6/B7, §9.8): ρύζι 250, πατάτα 400, φρούτο 1,5 τεμ., μέλι 20 = ιδανικό/γεύμα. Στάδιο 0 γεμίζει έως το ιδανικό,
       στάδιο 1 πέραν αυτού προς το max — και τότε ο υδατάνθρακας δηλώνεται «carb-over-ideal» για να μπει 2ος υδατάνθρακας στο πιάτο. */
    var SECOND_CAP = 50; /* 8/9 (#16): ιδανικό 2ου υδατάνθρακα χωρίς δικό του ιδανικό (ψωμί 2 φέτες) */
    var capOf = function (x, stage) { var fd = x.fd; if (x.second) return Math.max(fd.min || 0, Math.min(fd.max, fd.ideal || SECOND_CAP)); return stage ? fd.max : Math.min(fd.max, fd.ideal || fd.max); };
    var capByProtein = function (fd, addG) {
      if (fd.p <= 0 || addG <= 0) return addG;
      var room = pBudget - (carbPNow() - carbP0);
      if (room <= 0) return 0;
      return Math.min(addG, Math.floor(room / (fd.p / 100)));
    };

    if (!tuneOnly) {
      /* Post-Workout: 10-20g, γρήγορη απορρόφηση πρώτα (§9.15) */
      var postG = 0;
      var postItems = items.filter(function (x) { return x.win === 'post'; });
      postItems.sort(function (a, b) { return (b.fd.fast ? 1 : 0) - (a.fd.fast ? 1 : 0); });
      postItems.forEach(function (x) {
        if (postG >= 10) return;
        var g = R((15 - postG) / (x.fd.c / 100));
        g = Math.max(x.fd.min, Math.min(x.fd.max, g));
        x.it.grams = g;
        postG += x.fd.c * g / 100;
      });

      /* Στόχοι παραθύρων στους ευέλικτους υδατάνθρακες (30/60/10, ±5% ενδεικτικά) */
      var trainFlex = Math.max(0, 0.60 * flexG - postG);
      var winTarget = {
        breakfast: 0.30 * flexG,
        pre: trainFlex * 0.45,
        main: trainFlex * 0.55,
        rest: 0.10 * flexG,
        flat: flexG
      };
      var fill = function (win) {
        var list = items.filter(function (x) { return x.win === win; });
        if (!list.length) return 0;
        if (proteinTight) list = list.slice().sort(byPDensity);
        var want = win === 'flat' ? winTarget.flat : winTarget[win];
        var remaining = want;
        list.forEach(function (x, k) {
          var share = remaining / (list.length - k);
          var g = R(share / (x.fd.c / 100));
          g = Math.min(capOf(x, 0), capByProtein(x.fd, g));
          if (g < x.fd.min) g = (g < x.fd.min / 2) ? 0 : x.fd.min;
          x.it.grams = g;
          remaining -= x.fd.c * g / 100;
        });
        /* στάδιο 1: ό,τι δεν χώρεσε στα ιδανικά πάει πέραν αυτών, προς το max (B7: εδώ ο συνθέτης βάζει 2ο υδατάνθρακα) */
        if (remaining > 1) list.forEach(function (x) {
          if (remaining <= 1) return;
          var cur = x.it.grams || 0, cap = capOf(x, 1); if (cur >= cap) return;
          var g2 = Math.min(cap, cur + capByProtein(x.fd, R(remaining / (x.fd.c / 100))));
          /* 8/9/2026 (Δοκιμαστής γ2 #7 — 3 g βρώμη, 7 g μπανάνα, 15 g τορτίγια): από το 0 είτε φτάνει το min (αν το χωρά ο προϋπολογισμός πρωτεΐνης) είτε μένει 0 — ποτέ ενδιάμεσα */
          if (g2 > 0 && g2 < x.fd.min) g2 = (g2 >= x.fd.min / 2 && capByProtein(x.fd, x.fd.min - cur) >= x.fd.min - cur) ? x.fd.min : cur;
          if (g2 > cur) { remaining -= x.fd.c * (g2 - cur) / 100; x.it.grams = g2; }
        });
        /* §9.15 (διόρθωση 4/9/2026): σε μέρα προπόνησης το Pre και το Κύριο ΔΕΝ μένουν ποτέ χωρίς υδατάνθρακα.
           Πριν, ένας πρωτεϊνούχος υδατάνθρακας (μακαρόνια/κινόα, 14-18 g Π/100 g) μηδενιζόταν όταν η πρωτεΐνη ήταν «σφιχτή»
           και το κύριο έβγαινε γαλοπούλα + πιπεριά + ελαιόλαδο. Τώρα ο φτωχότερος σε πρωτεΐνη κρατά τουλάχιστον το min του
           (keep) και οι πρωτεϊνικές πηγές κάνουν το trim στο επόμενο iteration. */
        if ((win === 'pre' || win === 'main') && list.every(function (x) { return !(x.it.grams > 0); })) {
          var keep = list.slice().sort(byPDensity)[0];
          keep.it.grams = keep.fd.min; keep.keep = true;
          remaining -= keep.fd.c * keep.fd.min / 100;
        }
        return want - remaining;
      };
      ['breakfast', 'pre', 'main', 'rest', 'flat'].forEach(fill);
    }

    /* Fine-tuning kcal ±25: rest → main → breakfast (όχι κάτω από 25% flex) → pre (μόνο αύξηση).
       Το Post-Workout δεν αγγίζεται ποτέ (§9.15). */
    var tuneOrder = ['rest', 'flat', 'main', 'breakfast', 'pre'], stage = 0;
    for (var iter = 0; iter < 40; iter++) {
      var gap = targets.kcal - dayTotals(meals).kcal;
      if (Math.abs(gap) <= 25) break;
      var adjusted = false;
      for (var w = 0; w < tuneOrder.length && Math.abs(gap) > 25; w++) {
        var win = tuneOrder[w];
        if (win === 'pre' && gap < 0) continue; /* ποτέ μείωση Pre-Workout */
        var list = items.filter(function (x) { return x.win === win; });
        if (proteinTight) {
          /* αύξηση: πρώτα οι φτωχές σε πρωτεΐνη · μείωση: πρώτα οι πλούσιες */
          list = list.slice().sort(byPDensity);
          if (gap < 0) list.reverse();
        }
        if (gap < 0 && stage === 0) list = list.slice().sort(function (a, b) { /* B6/B7: πρώτα κόβεται ό,τι ξεπερνά το ιδανικό του (μέλι 38 > 20 πριν από βρώμη) */
          var ea = a.fd.ideal ? (a.it.grams || 0) - a.fd.ideal : -1, eb = b.fd.ideal ? (b.it.grams || 0) - b.fd.ideal : -1; return (eb > 0) - (ea > 0);
        });
        /* 6/9/2026 (Δοκιμαστής #25 «porridge χωρίς βρώμη»): η ΜΕΙΩΣΗ kcal μοιράζεται αναλογικά σε όλους τους υδατάνθρακες του παραθύρου —
           πριν, ο πρώτος της λίστας (η βρώμη του πρωινού) έτρωγε όλη τη διόρθωση και μηδενιζόταν */
        var wKcal = 0; if (gap < 0) list.forEach(function (y) { wKcal += (y.it.grams || 0) * y.fd.kcal / 100; });
        for (var k = 0; k < list.length && Math.abs(gap) > 25; k++) {
          var x = list[k];
          var cur = x.it.grams || 0;
          var delta = (gap < 0 && wKcal > 0) ? R(gap * (cur * x.fd.kcal / 100) / wKcal / (x.fd.kcal / 100)) : R(gap / (x.fd.kcal / 100));
          if (gap < 0 && delta === 0 && cur > 0) delta = -1;
          if (delta > 0) delta = capByProtein(x.fd, delta);
          var ng = cur + delta;
          ng = Math.min(delta > 0 ? capOf(x, stage) : x.fd.max, ng);
          if (delta < 0 && stage === 0 && x.fd.ideal) ng = Math.max(ng, Math.min(cur, x.fd.ideal)); /* B6/B7 κάθοδος: πρώτα ό,τι είναι ΠΑΝΩ από το ιδανικό, μετά (στάδιο 1) τα υπόλοιπα */
          if (ng < x.fd.min) {
            if (x.keep) ng = x.fd.min; /* §9.15: ο μοναδικός υδατάνθρακας του Pre/Κύριου δεν πέφτει κάτω από το min */
            else if (ng < x.fd.min / 2) ng = 0;
            else if (delta > 0 && capByProtein(x.fd, x.fd.min - cur) < x.fd.min - cur) ng = cur >= x.fd.min ? cur : 0; /* 8/9 (#7): δεν μένει ποσότητα κάτω από το min */
            else ng = x.fd.min;
          }
          if (win === 'breakfast' && ng < cur) {
            /* floor: το πρωινό κρατά ≥25% των ευέλικτων υδατανθράκων (§9.15) */
            var bNow = 0;
            items.forEach(function (y) { if (y.win === 'breakfast') bNow += y.fd.c * (y.it.grams || 0) / 100; });
            var bAfter = bNow - x.fd.c * (cur - ng) / 100;
            if (bAfter < 0.25 * flexG) continue;
          }
          if (ng !== cur) {
            gap -= (ng - cur) * x.fd.kcal / 100;
            x.it.grams = ng;
            adjusted = true;
          }
        }
      }
      if (!adjusted) { if (stage === 0 && Math.abs(gap) > 25) { stage = 1; continue; } break; } /* όλοι στο ιδανικό και λείπουν/περισσεύουν kcal → στάδιο 1 (πέραν/κάτω από το ιδανικό) */
    }
  }

  /* ---------- §9.6 κοινό ταβάνι κρόκων (Α6, 5/9/2026): ολόκληρα αυγά + κρόκοι ≤ 34 g κρόκου/ημέρα ---------- */
  function enforceYolkCap(meals, issues) {
    var over = dayYolkEq(meals) - YOLK_DAY_CAP;
    if (over <= 0.5) return;
    /* πρώτα κόβονται τα ολόκληρα αυγά πάνω από το min τους, μετά οι κρόκοι πάνω από το min τους */
    var items = [];
    meals.forEach(function (m) { m.foods.forEach(function (it) { if (yolkOf(it) > 0) items.push({ it: it, m: m, fd: fdOf(it) }); }); });
    items.sort(function (a, b) { return (b.fd.yolkEq || 1) - (a.fd.yolkEq || 1); });
    items.forEach(function (x) {
      if (over <= 0.5) return;
      var eq = x.it.name === 'Αυγά Κρόκος' ? 1 : x.fd.yolkEq, g = x.it.grams || 0, floor = x.fd.min || 0;
      var cutG = Math.min(g - floor, Math.ceil(over / eq));
      if (cutG <= 0) return;
      x.it.grams = g - cutG; over -= cutG * eq;
    });
    if (over > 0.5) issues.push({ type: 'yolk-cap', got: R(dayYolkEq(meals)), max: YOLK_DAY_CAP,
      suggest: 'Ολόκληρα αυγά και κρόκοι μαζί ξεπερνούν τους 2 κρόκους την ημέρα (§9.6). Βγάλε αυγό ή κρόκο από ένα γεύμα.' });
  }

  /* ---------- §10.1 containers + ασυμβατότητα macros (πριν τη λύση) — η §9.11 πρωτεΐνης τρέχει στο τέλος (v3) ---------- */
  function preFeasibility(meals, spec, issues) {
    /* §9.11: αν P+F μόνα τους ξεπερνούν το kcal budget, κανένα πλάνο δεν βγαίνει */
    var macroKcal = spec.targets.p * 4 + spec.targets.f * 9;
    if (macroKcal > spec.targets.kcal + 25) {
      issues.push({ type: 'macro-kcal-conflict', macroKcal: R(macroKcal), target: R(spec.targets.kcal),
        suggest: 'Πρωτεΐνη + λιπαρά δίνουν ήδη ' + R(macroKcal) + ' kcal, πάνω από τον στόχο ' +
          R(spec.targets.kcal) + ' kcal — οι στόχοι macros είναι ασύμβατοι μεταξύ τους (§9.11/§9.12).' });
    }
    var lockedKcal = 0, minOtherKcal = 0, maxP = 0, minP = 0, wheyPresent = false;
    var containers = [];
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role === 'container') {
          var u = it.units || 1;
          lockedKcal += fd.kcal * u;
          maxP += fd.p * u; minP += fd.p * u;
          containers.push({ name: it.name, kcal: R(fd.kcal * u) });
        } else if (fd.locked) {
          lockedKcal += fd.kcal * (it.grams || fd.locked[0]) / 100;
          maxP += fd.p * (it.grams || fd.locked[0]) / 100;
          minP += fd.p * fd.locked[0] / 100;
        } else if (actsAsMain(it, m)) {
          var mn = foodMin(fd, spec.sex);
          minOtherKcal += fd.kcal * mn / 100;
          minP += fd.p * mn / 100;
          maxP += fd.p * fd.max / 100;
        } else if (fd.role === 'secondary' || fd.role === 'tier2') {
          if (fd.wheyCap) { wheyPresent = true; maxP += fd.p * 45 / 100; }
          else maxP += fd.p * fd.max / 100;
        } else if (fd.role === 'veg' || fd.role === 'extra') {
          minOtherKcal += fd.kcal * foodMin(fd, spec.sex) / 100;
        }
      });
    });
    /* §10.1: containers που δεν χωρούν */
    if (lockedKcal + minOtherKcal > spec.targets.kcal + 25 && containers.length) {
      containers.forEach(function (c) {
        issues.push({ type: 'container-overflow', container: c.name, kcal: c.kcal, target: R(spec.targets.kcal),
          suggest: 'Το ' + c.name + ' προσθέτει ' + c.kcal + ' kcal — ο στόχος είναι ' + R(spec.targets.kcal) +
            ' kcal. α) Αφαίρεσέ το, ή β) μείωσε δραστικά άλλα γεύματα (§10.1).' });
      });
    } else if (lockedKcal + minOtherKcal > spec.targets.kcal + 25) {
      issues.push({ type: 'kcal-infeasible', min: R(lockedKcal + minOtherKcal), target: R(spec.targets.kcal),
        suggest: 'Οι ελάχιστες ποσότητες των τροφών δίνουν ' + R(lockedKcal + minOtherKcal) +
          ' kcal, πάνω από τον στόχο ' + R(spec.targets.kcal) + ' kcal (§9.12). Αφαίρεσε τροφή ή γεύμα.' });
    }
    /* §9.11 πρωτεΐνη: v3 (ΣΤ.9) — το εφικτό εύρος υπολογίζεται ΜΙΑ φορά, στο τέλος, πάνω στην τελική σύνθεση (diagnose), όχι εδώ */
    if (spec.targets.p < minP - 3) {
      issues.push({ type: 'protein-min-exceeds', min: R(minP), target: R(spec.targets.p),
        suggest: 'Οι ελάχιστες ποσότητες δίνουν ήδη ' + R(minP) + 'g πρωτεΐνη, πάνω από τον στόχο ' +
          R(spec.targets.p) + 'g (§9.12). Αφαίρεσε πρωτεϊνική τροφή ή γεύμα.' });
    }
  }

  /* ---------- Λύση ημέρας με δεδομένες ποσότητες κλειδωμένων τροφών (v3, 9/9/2026: σχέδιο 10 Β.1-Β.6) ----------
     Στάδια: 1 κλειδωμένα πρώτα (allocateProtein) → 2 γέμισμα ευέλικτων (iter 0) → 3 εξισορρόπηση ημέρας + ΜΕΤΑΦΟΡΑ (balanceProteinDay/transferProtein)
     → 4 ΣΥΜΠΛΗΡΩΣΗ από τις αποδεκτές τροφές του χρήστη (spec.pool + spec.fits — completeDay) → 5 τελική εξισορρόπηση + ακέραια γραμμάρια (finishDay)
     → 6 ΔΗΛΩΣΗ μόνο από την τελική σύνθεση (diagnose). Κανένα rebuild μετά το iter 0 (ταλαντώνεται) — όλα τα re-solve είναι tune-only. */
  var MAX_ADD = 3;           /* Ζ.4 (owner 9/9/2026): έως 3 προσθήκες/μέρα, το πολύ 1 ανά γεύμα */
  var WHEY_ADD_MIN = 25;     /* Ζ.3 (owner 9/9/2026): ελάχιστη ουσιαστική προσθήκη whey = 1 σκουπ */
  var WHEY_NAME = 'Πρωτεΐνη Whey Isolate';
  var TIER2_ORDER = ['Τυρί Νουνού Light', 'Φέτα Ήπειρος Slim', 'Μοτσαρέλα', 'Ταλαγάνι'];
  var SEC_ORDER = ['Γιαούρτι Νουνου 1.5%', 'Γιαούρτι Κρι Κρι High Protein 0%', 'Cottage 4%', 'Αυγά Ασπράδι', 'Ενταμάμε Φασόλια', 'Γαλοπούλα Καπνιστή Στήθος', 'Γαλοπούλα Αλλαντικό', 'Αυγό Ολόκληρο', 'Γάλα Protein Plus', 'Γάλα Light'];
  /* ασπράδι μόνο όπου μαγειρεύεται (γ2 #6): ποτέ σε γεύμα με γιαούρτι/whey/γάλα/cottage/φρούτο/μέλι/βρώμη (ο συνθέτης το κρίνει από τη μορφή· εδώ ο κανόνας για τον απλό δρόμο) */
  var SWEET_BOWL = ['Γιαούρτι Νουνου 1.5%', 'Γιαούρτι Κρι Κρι High Protein 0%', WHEY_NAME, 'Γάλα Light', 'Γάλα Protein Plus']; /* γ2 #15: ψωμί/τορτίγια/κράκερς ποτέ 2ος Υ σε γιαουρτόμπολ/shake/porridge (μόνο με cottage) */
  var RAW_NO = ['Γιαούρτι Νουνου 1.5%', 'Γιαούρτι Κρι Κρι High Protein 0%', WHEY_NAME, 'Γάλα Light', 'Γάλα Protein Plus', 'Cottage 4%', 'Μέλι', 'Μπανάνα', 'Μήλο', 'Χουρμάδες', 'Βρώμη'];
  var STARCH_ADD = ['Ρύζι Μπασμάτι', 'Πατάτα', 'Γλυκοπατάτα', 'Μακαρόνια Fitness', 'Κινοα', 'Egg Noodles', 'Νιοκι Πατατας', 'Ψωμί Τόστ', 'Τορτίγια Ολικής', 'Τορτίγια Protein', 'Φοκάτσια'];
  var LIGHT_ADD = ['Ψωμί Τόστ', 'Βρώμη', 'Μπανάνα', 'Μήλο', 'Φρυγανιά Σίκαλης Wasa', 'Κρακερς', 'Τορτίγια Ολικής', 'Τορτίγια Protein'];
  var isPostName = function (n) { return /post[- ]?workout/i.test(n || ''); };
  var clone = function (x) { return JSON.parse(JSON.stringify(x)); };
  var namesOf = function (m) { return m.foods.map(function (it) { return it.name; }); }; /* ΟΛΕΣ οι τροφές του γεύματος (και όσες ο solver έχει στο 0 τώρα — ο χρήστης τις έβαλε εκεί, το ταίριασμα τις μετρά) */

  /* Σκορ λύσης — ίδιο με το solverScore του συνθέτη (composer.js): εφικτότητα → ρεαλισμός → απόκλιση */
  function solverScore(res) {
    var x = 0;
    res.issues.forEach(function (i) {
      if (i.type === 'secondary-over-ideal') x += 3 * (i.grams - i.ideal);
      if (i.type === 'protein-uneven') x += 9 * Math.max(0, Math.abs(i.dev) - i.tol);
      if (i.type === 'fat-over-ideal') x += 6 * (i.grams - i.ideal);
      if (i.type === 'carb-over-ideal') x += 2 * (i.grams - i.ideal);
      if (i.type === 'whey-exception') x += 25 * (i.grams - 45);
      if (i.type === 'meal-under-min-protein') x += 9 * (i.min - i.got);
    });
    return (res.withinLimits ? 0 : 100000) + x + Math.abs(res.diff.kcal) + 4 * Math.abs(res.diff.p) + 9 * Math.abs(res.diff.f);
  }

  function prepareMeals(meals, spec) {
    markSides(meals);
    /* λαχανικά: μετρώνται στα macros. 6/9/2026 (owner B4, Δοκιμαστής #11): σε ΚΥΡΙΟ γεύμα (μεσημεριανό/βραδινό/κύριο) πραγματική μερίδα —
       150 g ανά λαχανικό, ταβάνι 250 g ωμά συνολικά στο γεύμα (2 λαχανικά → 125 + 125)· σε πρωινό/σνακ στην ελάχιστη μερίδα. Έξτρα πάντα στο min. */
    meals.forEach(function (m) {
      var vegs = m.foods.filter(function (it) { return fdOf(it).role === 'veg' && !it.grams; });
      var per = (isMainMeal(m) && vegs.length) ? Math.floor(Math.min(VEG_IDEAL, VEG_MEAL_CAP / vegs.length) / 5) * 5 : 0;
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if ((fd.role === 'veg' || fd.role === 'extra') && !it.grams) it.grams = (fd.role === 'veg' && per) ? Math.min(fd.max, Math.max(foodMin(fd, spec.sex), per)) : foodMin(fd, spec.sex);
      });
    });
  }

  /* Βρόχος σύγκλισης: από iter 0 = κατασκευή (fillMealProtein), από iter ≥1 = μόνο διορθώσεις (tune-only υδατάνθρακες).
     Το target §9.9 ξαναϋπολογίζεται σε κάθε iteration (allocateProtein — η παθητική πρωτεΐνη των κλειδωμένων γευμάτων αλλάζει με τους υδατάνθρακες). */
  function runLoop(meals, spec, issues, startIter) {
    var alloc = null;
    for (var iter = startIter; iter < 20; iter++) {
      alloc = allocateProtein(spec.targets.p, meals, spec.sex);
      if (iter === 0) alloc.flexMeals.forEach(function (m) { fillMealProtein(m, spec.sex); });
      balanceProteinDay(meals, spec.targets, spec.sex, issues);
      enforceMealMinimums(meals, alloc.flexMeals, spec.sex, issues, false);
      solveFats(meals, spec.targets.f, issues, spec.autoFats);
      solveCarbs(meals, spec.dayType, spec.targets, spec.sex, issues, iter > 0);
      var t = dayTotals(meals);
      if (Math.abs(t.kcal - spec.targets.kcal) <= 25 && Math.abs(t.p - spec.targets.p) <= 3 && Math.abs(t.f - spec.targets.f) <= 3) break;
    }
    return alloc || allocateProtein(spec.targets.p, meals, spec.sex);
  }

  /* Τελικό στάδιο με αυστηρή σειρά: (1) boost των hard minimums §9.9, (2) εξισορρόπηση ημέρας αν το boost/tuner άφησε την πρωτεΐνη εκτός ±3g,
     (3) τελευταία μεταφορά με kcal-guard (Β.5), (4) αναφορά minimums με τα οριστικά νούμερα — ΚΑΙ για κλειδωμένα γεύματα (1 κονσέρβα τόνου = 27 g < 30, δηλωμένο),
     (5) κρόκοι, (6) below-min δίχτυ, (7) ακέραια γραμμάρια. */
  function finishDay(meals, spec, issues) {
    var alloc = allocateProtein(spec.targets.p, meals, spec.sex);
    enforceMealMinimums(meals, alloc.flexMeals, spec.sex, issues, false);
    if (Math.abs(dayTotals(meals).p - spec.targets.p) > 3) {
      balanceProteinDay(meals, spec.targets, spec.sex, issues);
      solveFats(meals, spec.targets.f, issues, spec.autoFats);
    }
    transferProtein(meals, spec.sex, { kcalTarget: spec.targets.kcal });
    enforceMealMinimums(meals, meals, spec.sex, issues, true);
    enforceYolkCap(meals, issues);
    /* 6/9/2026 (devil): τα γραμμάρια που ΒΛΕΠΕΙ ο χρήστης είναι ακέραια — τα σύνολα υπολογίζονται από τα ΙΔΙΑ ακέραια γραμμάρια */
    /* 8/9/2026 (Δοκιμαστής γ2 #7): δίχτυ ασφαλείας — καμία μη κλειδωμένη τροφή δεν βγαίνει με ποσότητα κάτω από το min της (§8/§9.4: είτε ≥ min είτε φεύγει) */
    meals.forEach(function (m) { m.foods.forEach(function (it) {
      var fd = fdOf(it); if (fd.role === 'container' || fd.locked || !(it.grams > 0)) return;
      var mn = fd.legume ? (it.side ? 40 : foodMin(fd, spec.sex)) : (fd.min || 0);
      if (mn && it.grams < mn - 0.5) { issues.push({ type: 'below-min-removed', meal: m.name, food: it.name, grams: R(it.grams), min: mn }); it.grams = 0; }
    }); });
    meals.forEach(function (m) { m.foods.forEach(function (it) { if (fdOf(it).role !== 'container' && it.grams) it.grams = R(it.grams); }); });
    /* 9/9/2026 (τράπουλα seed 2: «Πολύ cottage 202 g (ιδανικό 200)»): υπέρβαση ιδανικού ≤3 g από στρογγυλοποίηση/περιθώριο μεταφοράς ΔΕΝ είναι μήνυμα —
       η δευτερεύουσα/ο υδατάνθρακας κλειδώνει στο ιδανικό (≤0,4 g Π / ≤4 kcal διαφορά, μέσα στα ±3/±25 της §11) */
    meals.forEach(function (m) { m.foods.forEach(function (it) {
      var fd = fdOf(it); if (!fd.ideal || (fd.role !== 'secondary' && fd.role !== 'carb') || !(it.grams > fd.ideal) || it.grams > fd.ideal + 3) return;
      it.grams = fd.ideal;
    }); });
    return alloc;
  }

  function dedupeIssues(issues) {
    var seen = {};
    return issues.filter(function (i) {
      var key = i.type + '|' + (i.meal || '') + '|' + (i.food || '') + '|' + (i.container || '');
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  /* ---------- Στάδιο 6: ΔΗΛΩΣΗ μόνο από την τελική σύνθεση (Β.6) ---------- */
  function diagnose(meals, spec, issues, ctx) {
    issues = dedupeIssues(issues);
    var pool = ctx.pool, fits = ctx.fits;
    /* 11/9/2026 (γύρος 21, devil): αγνή πρωτεΐνη που ΗΤΑΝ στο γεύμα και έφυγε από το δίχτυ below-min (ημέρα στο όριο θερμίδων) καταγράφεται ως «δοκιμάστηκε» —
       αλλιώς η whey που μπαίνει μετά φαίνεται σαν να προτιμήθηκε από γιαούρτι/αυγό που «ταίριαζαν» ενώ στην πραγματικότητα δεν χωρούσαν στις θερμίδες */
    if (ctx.tried) issues.forEach(function (i) {
      var fd = i.type === 'below-min-removed' && FOODS[i.food];
      if (fd && /main|tier2|secondary/.test(fd.role) && !ctx.tried.some(function (t) { return t.meal === i.meal && t.food === i.food; })) ctx.tried.push({ meal: i.meal, food: i.food, why: 'αφαιρέθηκε: έμενε ' + i.grams + ' g, κάτω από το ελάχιστο ' + i.min + ' g (όριο θερμίδων)' });
    });
    /* ίδιο για αγνή πρωτεΐνη του χρήστη που η σκάλα/η κάθοδος μηδένισε (μέρα στο όριο θερμίδων: η whey δίνει την ίδια πρωτεΐνη με λιγότερες kcal — λύση ανάγκης, δηλωμένη) */
    if (ctx.tried) meals.forEach(function (m) { m.foods.forEach(function (it) {
      var fd = fdOf(it); if (it.added || fd.role === 'container' || !/main|tier2|secondary/.test(fd.role) || it.grams > 0) return;
      if (!ctx.tried.some(function (t) { return t.meal === m.name && t.food === it.name; })) ctx.tried.push({ meal: m.name, food: it.name, why: 'ήταν στο γεύμα και μηδενίστηκε (όριο θερμίδων/πρωτεΐνης)' });
    }); });
    var t = dayTotals(meals);
    var res = {
      ok: true,
      meals: meals.map(function (m) {
        var o = {
          name: m.name,
          items: m.foods.filter(function (it) { return fdOf(it).role === 'container' || (it.grams || 0) > 0; }).map(function (it) {
            var fd = fdOf(it);
            var out = { name: it.name };
            if (fd.role === 'container') out.units = it.units || 1;
            else out.grams = R(it.grams || 0);
            if (it.auto) out.auto = true;
            if (it.added) out.added = true; /* v3: μπήκε από τη συμπλήρωση (Β.4) */
            /* §9.10: τεμάχια στο 0,5 — εμφανίζονται μόνο όταν ≥1 (το UI κρίνει) */
            if (fd.piece && out.grams) { var stp = (fd.piece >= 150 || fd.cup) ? 4 : 2; out.pieces = Math.round(out.grams / fd.piece * stp) / stp; } /* 6/9 (owner 4δ): βήμα ¼ για μονάδες ≥150 g και μεζούρες, αλλιώς ½ */
            return out;
          }),
          totals: (function (v) { return { kcal: R(v.kcal), p: R(v.p), c: R(v.c), f: R(v.f) }; })(mealTotals(m))
        };
        if (m.lockedMeal) o.locked = true;
        if (m.pTarget != null) { o.pTarget = R(m.pTarget); o.pTol = m.pTol; }
        return o;
      }),
      totals: { kcal: R(t.kcal), p: R(t.p), c: R(t.c), f: R(t.f) },
      targets: { kcal: R(spec.targets.kcal), p: R(spec.targets.p), f: R(spec.targets.f) },
      diff: { kcal: R(t.kcal - spec.targets.kcal), p: R(t.p - spec.targets.p), f: R(t.f - spec.targets.f) },
      issues: issues,
      added: ctx.added || [], tried: ctx.tried || [], notes: ctx.notes || []
    };
    if (ctx.suggest) res.suggest = ctx.suggest;
    /* §11 όρια — ρητή αναφορά με πρόταση, ποτέ σιωπηλή υπέρβαση (§9.12). Διάγνωση βάσει τελικής κατάστασης. */
    var carbItems = [], carbsMaxed = true, carbsEmpty = true, protAtFloor = true, fatsEmpty = true;
    var minPerMealDiag = spec.sex === 'm' ? 30 : 20;
    var passiveP = 0, maxP = 0, wheyMeals = 0, wheyAvailable = false;
    meals.forEach(function (m) {
      var mealAtHardMin = mealTotals(m).p <= minPerMealDiag + 2.5;
      var hasWhey = false;
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role === 'carb') {
          carbItems.push(it);
          if ((it.grams || 0) < fd.max) carbsMaxed = false;
          if ((it.grams || 0) > 0) carbsEmpty = false;
          passiveP += fd.p * (it.grams || 0) / 100;
        } else if (fd.role === 'fat' || fd.role === 'veg' || fd.role === 'extra') {
          if (fd.role === 'fat' && (it.grams || 0) > 0) fatsEmpty = false;
          passiveP += fd.p * (it.grams || 0) / 100;
        } else if (fd.role === 'container') { maxP += fd.p * (it.units || 1); }
        else if (fd.locked) { maxP += fd.p * (it.grams || 0) / 100; }
        else if (fd.role === 'main' || fd.role === 'tier2' || fd.role === 'secondary') {
          /* «δάπεδο»: το δικό του min, ή το hard min §9.9 του γεύματος (δεν κόβεται κι άλλο) */
          var floor = (fd.role === 'secondary') ? 0 : foodMin(fd, spec.sex);
          if ((it.grams || 0) > floor && !mealAtHardMin) protAtFloor = false;
          if (fd.wheyCap) { hasWhey = (it.grams || 0) > 0; wheyAvailable = true; maxP += fd.p * Math.max(45, Math.min(WHEY_HARD_CAP, it.grams || 0)) / 100; }
          else maxP += fd.p * fd.max / 100;
        }
      });
      if (hasWhey) wheyMeals++;
    });
    maxP += passiveP;
    if (!carbItems.length) carbsEmpty = true;
    if (res.diff.kcal < -25 && carbsMaxed) {
      issues.push({ type: 'carb-capacity-infeasible', diff: res.diff.kcal,
        suggest: 'Οι υδατανθρακούχες τροφές είναι στα maximums και λείπουν ' + (-res.diff.kcal) + ' kcal — πρόσθεσε υδατανθρακούχα τροφή σε γεύμα (§9.11/§9.12).' });
    } else if (res.diff.kcal > 25 && carbsEmpty) {
      issues.push({ type: 'kcal-floor-conflict', diff: res.diff.kcal,
        suggest: 'Ακόμα και χωρίς καθόλου υδατάνθρακες το πλάνο ξεπερνά τον στόχο κατά ' + res.diff.kcal + ' kcal — αφαίρεσε τροφή/container (§9.12).' });
    } else if (Math.abs(res.diff.kcal) > 25) {
      issues.push({ type: 'kcal-out-of-tolerance', diff: res.diff.kcal,
        suggest: res.diff.kcal > 0 ? 'Αφαίρεσε τροφή/container ή μείωσε γεύμα (§9.12).' : 'Πρόσθεσε υδατανθρακούχα τροφή σε κάποιο γεύμα (§9.12).' });
    }
    /* §9.11 (v3, ΣΤ.9): το feasibility πρωτεΐνης τρέχει ΜΙΑ φορά, ΕΔΩ, πάνω στην τελική σύνθεση ΜΕΤΑ τη συμπλήρωση —
       max = κλειδωμένα + παθητική πρωτεΐνη στα τελικά γραμμάρια + ευέλικτες πηγές στα max τους (whey 45 ή όσο έφτασε με §9.7.1). Ποτέ μικρότερο από όσο βγήκε (#20). */
    if (res.diff.p > 3 && protAtFloor) {
      issues.push({ type: 'protein-floor-conflict', diff: res.diff.p,
        suggest: 'Με τις πρωτεϊνικές τροφές στα ελάχιστά τους η ημέρα έχει ήδη +' + res.diff.p + 'g πρωτεΐνη πάνω από τον στόχο — αφαίρεσε πρωτεϊνική τροφή (§9.12).' });
    } else if (res.diff.p < -3 && spec.targets.p > Math.max(maxP, t.p) + 3) {
      var missP = missingProteinFood(meals, ctx, null);
      issues.push({ type: 'protein-infeasible', max: R(Math.max(maxP, t.p)), target: R(spec.targets.p), tried: ctx.tried, missing: missP,
        suggest: 'Μέγιστη εφικτή πρωτεΐνη ' + R(Math.max(maxP, t.p)) + 'g, στόχος ' + R(spec.targets.p) + 'g (§9.11). ' + (missP ? 'Πρόσθεσε ' + missP + ' στα αγαπημένα σου (§9.12).' : 'Πρόσθεσε πρωτεϊνική τροφή σε γεύμα (§9.12).') });
    } else if (Math.abs(res.diff.p) > 3) {
      issues.push({ type: 'protein-out-of-tolerance', diff: res.diff.p,
        suggest: res.diff.p > 0 ? 'Αφαίρεσε πρωτεϊνική τροφή από γεύμα (§9.12).' : 'Πρόσθεσε πρωτεϊνική τροφή σε γεύμα (§9.12).' });
    }
    if (res.diff.f > 3 && fatsEmpty) {
      issues.push({ type: 'fat-floor-conflict', diff: res.diff.f,
        suggest: 'Τα εγγενή λιπαρά των τροφών ξεπερνούν τον στόχο κατά ' + res.diff.f + 'g — προτίμησε πιο άπαχη πηγή (π.χ. σολομός 125g, κοτόπουλο αντί μοσχάρι) (§9.12).' });
    } else if (Math.abs(res.diff.f) > 3) {
      issues.push({ type: 'fat-out-of-tolerance', diff: res.diff.f,
        suggest: res.diff.f > 0 ? 'Προτίμησε πιο άπαχη πρωτεϊνική πηγή (π.χ. σολομός 125g αντί 250g) (§9.12).' : 'Πρόσθεσε πηγή λιπαρών (ελαιόλαδο/καρύδια) σε γεύμα (§9.12).' });
    }
    /* §9.8.2: δευτερεύουσα πάνω από τη ρεαλιστική μερίδα της (ideal) — ΠΟΤΕ σιωπηλά. Ρεαλισμός, όχι όριο §11: res.realistic=false + ορατό μήνυμα. */
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role !== 'secondary' || !fd.ideal || (it.grams || 0) <= fd.ideal + 0.5) return;
        var missS = missingProteinFood(meals, ctx, m);
        issues.push({ type: 'secondary-over-ideal', meal: m.name, food: it.name, grams: R(it.grams), ideal: fd.ideal, missing: missS,
          suggest: 'Στο ' + m.name + ' βγαίνουν ' + R(it.grams) + 'g ' + it.name + ' (ρεαλιστική μερίδα ' + fd.ideal + 'g, §9.8). ' + (missS ? 'Πρόσθεσε ' + missS + ' στο γεύμα (§9.8.2).' : 'Πρόσθεσε δεύτερη πηγή πρωτεΐνης στο γεύμα (whey ή τυρί) (§9.8.2).') });
      });
    });
    /* 6/9/2026 (owner B6/B7, §9.8): υδατάνθρακας πάνω από το ιδανικό του γεύματος — ΠΟΤΕ σιωπηλά. v3: η συμπλήρωση έβαλε ήδη 2ο/3ο υδατάνθρακα αν υπήρχε
       αποδεκτός που ταιριάζει· ό,τι μένει δηλώνεται με τη ΣΥΓΚΕΚΡΙΜΕΝΗ τροφή/ποσότητα που λείπει (owner 9/9: ποτέ «περισσότερα γεύματα»). */
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role !== 'carb' || !fd.ideal || (it.grams || 0) <= fd.ideal + 0.5) return;
        var missC = missingCarbFood(meals, m, it, ctx);
        issues.push({ type: 'carb-over-ideal', meal: m.name, food: it.name, grams: R(it.grams), ideal: fd.ideal, missing: missC,
          suggest: 'Στο ' + m.name + ' βγαίνουν ' + R(it.grams) + 'g ' + it.name + ' (ιδανικό ' + fd.ideal + 'g, §9.8). ' + (missC ? 'Λείπει υδατάνθρακας που ταιριάζει: ~' + missC.grams + ' g ' + missC.food + ' στο γεύμα.' : 'Πρόσθεσε δεύτερο υδατάνθρακα στο γεύμα.') });
      });
    });
    /* §9.6.1 (5/9/2026): λιπαρή τροφή πάνω από τη μερίδα της (ideal) — ΠΟΤΕ σιωπηλά (ρεαλισμός, όχι όριο §11) */
    meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        var fd = fdOf(it);
        if (fd.role !== 'fat' || !fd.ideal || (it.grams || 0) <= fd.ideal + 0.5) return;
        issues.push({ type: 'fat-over-ideal', meal: m.name, food: it.name, grams: R(it.grams), ideal: fd.ideal,
          suggest: 'Στο ' + m.name + ' βγαίνουν ' + R(it.grams) + 'g ' + it.name + ' (μερίδα έως ' + fd.ideal + 'g, §9.6.1). Πρόσθεσε λιπαρή τροφή σε άλλο γεύμα για να μοιραστούν.' });
      });
    });
    /* §9.9 (v3): ανισοκατανομή πρωτεΐνης ΜΟΝΟ ό,τι δεν λύθηκε με μεταφορά (Β.3) ή συμπλήρωση (Β.4) — ΠΟΤΕ σιωπηλά, με τη συγκεκριμένη τροφή που θα το έλυνε. */
    var ladderD = proteinLadder(meals, spec.sex);
    meals.forEach(function (m) {
      if (m.pTarget == null) return;
      var got = mealTotals(m).p, dev = got - m.pTarget;
      if (Math.abs(dev) <= m.pTol + 0.5) return;
      if (m.pCapped && dev < 0) return; /* §9.9 1α: whey-only γεύμα στο ταβάνι του — το έλλειμμα μοιράστηκε αλλού, δεν είναι ανισοκατανομή */
      var missU = dev < 0 ? missingProteinFood(meals, ctx, m) : null;
      var triedHere = (ctx.tried || []).filter(function (x) { return x.meal === m.name; });
      /* ΑΙΤΙΑ (αρχή owner 9/9/2026 — «θέλω να δω ΓΙΑΤΙ φτάσαμε εκεί»): day-short = λείπει πρωτεΐνη στην ημέρα (η συμπλήρωση δεν είχε τι να βάλει) ·
         main-at-min = τα γεύματα πάνω από τον στόχο έχουν την κύρια τους στο ελάχιστο (150 g) ή κλειδωμένη — δεν υπάρχει από πού να μεταφερθεί ·
         no-source = κανένα γεύμα πάνω από τον στόχο του · transfer-failed = υπήρχε πηγή αλλά η μεταφορά δεν χώρεσε (π.χ. η whey του γεύματος ήδη 45) */
      var cause = null, stuck = null;
      if (dev < 0) {
        if (t.p < spec.targets.p - 3) cause = 'day-short';
        else if (m.foods.some(function (it) { return it.added; })) cause = 'add-limit'; /* Ζ.4: μία προσθήκη ανά γεύμα ήδη έγινε — δεν επιτρέπεται δεύτερη */
        else {
          var srcs = meals.filter(function (o) { return o !== m && o.pTarget != null && mealTotals(o).p - o.pTarget > 0.5; });
          if (!srcs.length) cause = 'no-source';
          else if (srcs.every(function (o) { return !ladderD.down.some(function (d) { return d.m === o && (d.it.grams || 0) > d.floor + 0.01; }); })) {
            cause = 'main-at-min'; stuck = srcs.map(function (o) { return o.foods.filter(function (it) { return actsAsMain(it, o) || fdOf(it).locked; }).map(function (it) { return it.name + ' ' + R(it.grams || 0) + ' g'; }).join(', '); }).join(' · ');
          } else cause = 'transfer-failed';
        }
      }
      var why = cause === 'main-at-min' ? ' Η κύρια του άλλου γεύματος είναι ήδη στο ελάχιστό της (' + stuck + ') — δεν υπάρχει από πού να μεταφερθεί.' : cause === 'add-limit' ? ' Μπήκε ήδη μία τροφή σε αυτό το γεύμα (μία προσθήκη ανά γεύμα).' : '';
      issues.push({ type: 'protein-uneven', meal: m.name, got: R(got), target: R(m.pTarget), tol: m.pTol, dev: R(dev), missing: missU, tried: triedHere, cause: cause, stuck: stuck,
        suggest: dev < 0
          ? 'Στο ' + m.name + ' βγαίνουν ' + R(got) + 'g πρωτεΐνη αντί για ~' + R(m.pTarget) + 'g (§9.9).' + why + ' ' + (missU ? 'Πρόσθεσε ' + missU + ' στο γεύμα.' : 'Πρόσθεσε whey ή τυρί στο γεύμα.')
          : 'Στο ' + m.name + ' μαζεύονται ' + R(got) + 'g πρωτεΐνη αντί για ~' + R(m.pTarget) + 'g (§9.9). Πρόσθεσε πρωτεΐνη σε άλλο γεύμα για να μοιραστεί.' });
      if (dev < 0 && ctx.pool) ctx.notes.push({ type: 'uneven-unsolved', meal: m.name, cause: cause, why: (cause || '') + (stuck ? ' (' + stuck + ')' : '') + (triedHere.length ? ' · ' + triedHere.map(function (x) { return x.food + ': ' + x.why; }).join(' · ') : ' · καμία αποδεκτή τροφή που ταιριάζει') });
    });
    /* 6/9 (Δοκιμαστής #7): η υπέρβαση whey γράφεται στη σκάλα πριν την κάθοδο — διορθώνεται με την τελική ποσότητα, ή σβήνει αν τελικά ≤45 g */
    for (var wi = issues.length - 1; wi >= 0; wi--) {
      if (issues[wi].type !== 'whey-exception') continue;
      var wm = null; meals.forEach(function (m) { if (m.name === issues[wi].meal) wm = m; });
      var wg = 0; if (wm) wm.foods.forEach(function (it) { if (fdOf(it).wheyCap) wg = it.grams || 0; });
      if (wg <= 45.5) issues.splice(wi, 1); else issues[wi].grams = R(wg);
    }
    res.issues = issues;
    res.withinLimits = !issues.some(function (i) { return /tolerance|infeasible|overflow|under-min|min-exceeds|conflict/.test(i.type); });
    res.realistic = !issues.some(function (i) { return i.type === 'secondary-over-ideal' || i.type === 'protein-uneven' || i.type === 'carb-over-ideal'; });
    return res;
  }

  /* Ποια τροφή ΘΑ έλυνε το γεύμα (για τη δήλωση, §9.12: «η πρόταση είναι πάντα κάτι που ο solver θα χρησιμοποιούσε αν υπήρχε») */
  function missingProteinFood(meals, ctx, m) {
    var names = m ? namesOf(m) : [], fits = ctx.fits, inPool = function (n) { return ctx.pool ? ctx.pool.indexOf(n) >= 0 : true; };
    var ok = function (n) { return !fits || !m || fits(n, names, m.name); };
    var wheyMeals = 0; meals.forEach(function (x) { x.foods.forEach(function (it) { if (fdOf(it).wheyCap && (it.grams || 0) > 0) wheyMeals++; }); });
    if (m && isPostName(m.name)) return null;
    var rawBlocked = function (n) { return n === 'Αυγά Ασπράδι' && names.some(function (x) { return RAW_NO.indexOf(x) >= 0; }); };
    for (var j = 0; j < 4; j++) if (ok(SEC_ORDER[j]) && !rawBlocked(SEC_ORDER[j]) && names.indexOf(SEC_ORDER[j]) < 0) return SEC_ORDER[j]; /* αγνές πρώτα (owner 9/9) */
    for (var i = 0; i < TIER2_ORDER.length; i++) if (ok(TIER2_ORDER[i]) && names.indexOf(TIER2_ORDER[i]) < 0) return TIER2_ORDER[i];
    if (ok(WHEY_NAME) && wheyMeals < 2 && names.indexOf(WHEY_NAME) < 0) return 'whey';
    return null;
  }
  function missingCarbFood(meals, m, over, ctx) {
    var names = namesOf(m), fits = ctx.fits, fdo = fdOf(over);
    var mainMeal = isMainMeal(m), sweetBowl = names.some(function (n) { return SWEET_BOWL.indexOf(n) >= 0; }) && names.indexOf('Cottage 4%') < 0;
    var list = mainMeal ? STARCH_ADD : sweetBowl ? ['Βρώμη', 'Μπανάνα', 'Μήλο'] : LIGHT_ADD.concat(STARCH_ADD);
    for (var i = 0; i < list.length; i++) {
      var n = list[i], fd = FOODS[n]; if (!fd || names.indexOf(n) >= 0) continue;
      if (fits && !fits(n, names, m.name)) continue;
      var g = Math.max(fd.min, Math.min(fd.ideal || 50, R((over.grams - fdo.ideal) * fdo.c / fd.c)));
      return { food: n, grams: g };
    }
    return null;
  }

  /* ---------- Στάδιο 4 (Β.4): ΣΥΜΠΛΗΡΩΣΗ από τις αποδεκτές τροφές του χρήστη — «αν λείπουν 3 g στον τόνο, βάλε λίγη φέτα» ----------
     Σκάλα ανά γεύμα που υστερεί (ή έχει δευτερεύουσα > ιδανικό, ή έλλειμμα ημέρας) — owner 9/9/2026 γύρος 17: ΑΓΝΕΣ πρώτα, whey τελευταία:
     0 ό,τι υπάρχει ανεβαίνει (ήδη, Β.3) → 1 δευτερεύουσα έως το ιδανικό → 2 τυρί tier2 → 3 κύρια (μόνο χωρίς κύρια στο γεύμα, 1×/μέρα Κ-Δ) → 4 whey (pool, ≥25 g, ≤2 γεύματα §9.7, fits, όχι Post). Υδατάνθρακες: carb-over-ideal → 2ος/3ος Υ που ταιριάζει·
     kcal < στόχος−25 με Υ στα max → Υ που ταιριάζει στο γεύμα με τον λιγότερο. Κάθε προσθήκη ξαναλύνεται tune-only και κρατιέται ΜΟΝΟ αν το σκορ πέφτει (ΣΤ.1β)·
     ό,τι απορρίφθηκε γράφεται στο res.tried {meal, food, why}. Έως 3/μέρα, 1/γεύμα (Ζ.4). Δρόμος γεύμα-γεύμα (spec.suggestOnly): υπολογίζεται, ΔΕΝ εφαρμόζεται → res.suggest. */
  function completionCandidates(meals, res, spec, pool, fits, addedMeals) {
    var out = [], tried = [];
    var byName = {}; meals.forEach(function (m, i) { byName[m.name] = i; });
    var wheyMeals = 0, dayMains = {}, dayCnt = {};
    meals.forEach(function (m) { m.foods.forEach(function (it) { var fd = fdOf(it); if (fd.wheyCap && ((it.grams || 0) > 0 || it.grams == null)) wheyMeals++; if (fd.role === 'main' && !it.side) dayMains[it.name] = 1; dayCnt[it.name] = (dayCnt[it.name] || 0) + 1; }); });
    var inPool = function (n) { return pool.indexOf(n) >= 0 && FOODS[n] && (dayCnt[n] || 0) < 2; }; /* Κ-Γ (00-plaisio): ίδιο υλικό το πολύ σε 2 γεύματα τη μέρα — η συμπλήρωση δεν το παραβιάζει */
    var fitsIn = function (n, m) { if (n === 'Αυγά Ασπράδι' && namesOf(m).some(function (x) { return RAW_NO.indexOf(x) >= 0; })) return false; return !fits || fits(n, namesOf(m), m.name); };
    var score = function (n, m) { if (!spec.pairScore) return 0; var s = 0; namesOf(m).forEach(function (x) { s += spec.pairScore(n, x); }); return s; };
    var order = function (list, m) { return list.slice().sort(function (a, b) { return score(b, m) - score(a, m); }); };
    var needs = [];
    /* (α) γεύματα κάτω από target−ανοχή, από το πιο κάτω */
    res.issues.filter(function (i) { return i.type === 'protein-uneven' && i.dev < 0; }).sort(function (a, b) { return a.dev - b.dev; })
      .forEach(function (i) { needs.push({ mi: byName[i.meal], needP: Math.max(1, -i.dev - i.tol + 1), why: 'υστερεί ' + (-i.dev) + ' g' }); });
    /* (β) δευτερεύουσα πάνω από το ιδανικό: το πλεόνασμά της σε πρωτεΐνη */
    res.issues.filter(function (i) { return i.type === 'secondary-over-ideal'; }).sort(function (a, b) { return (b.grams - b.ideal) - (a.grams - a.ideal); })
      .forEach(function (i) { var fd = FOODS[i.food]; needs.push({ mi: byName[i.meal], needP: Math.max(1, (i.grams - i.ideal) * fd.p / 100 + 1), why: i.food + ' ' + i.grams + ' g > ιδανικό ' + i.ideal }); });
    /* (γ) έλλειμμα ημέρας ή γεύμα κάτω από το hard min: πρώτα τα γεύματα με τη λιγότερη πρωτεΐνη (και τα κλειδωμένα — η φέτα τα κάνει ευέλικτα) */
    var dayShort = res.diff.p < -3 || res.issues.some(function (i) { return /protein-infeasible|protein-out-of-tolerance|meal-under-min|whey-exception|whey-cap/.test(i.type) && !(i.type === 'protein-out-of-tolerance' && i.diff > 0); });
    if (dayShort) {
      var under = res.issues.filter(function (i) { return i.type === 'meal-under-min-protein'; });
      under.forEach(function (i) { needs.push({ mi: byName[i.meal], needP: Math.max(1, i.min - i.got + 1), why: 'κάτω από το ελάχιστο ' + i.min + ' g' }); });
      var asc = meals.map(function (m, i) { return i; }).sort(function (a, b) { return mealTotals(meals[a]).p - mealTotals(meals[b]).p; });
      asc.forEach(function (mi) { needs.push({ mi: mi, needP: Math.max(3, -res.diff.p), why: 'λείπουν ' + Math.max(3, -res.diff.p) + ' g στην ημέρα' }); });
    }
    var seenMeal = {};
    needs.forEach(function (nd) {
      var mi = nd.mi; if (mi == null || seenMeal[mi] || addedMeals[mi]) return;
      seenMeal[mi] = 1;
      var m = meals[mi], names = namesOf(m);
      if (isPostName(m.name)) { tried.push({ meal: m.name, food: '—', why: 'Post-Workout δεν παίρνει 2η πηγή (Κ-Ζ)' }); return; }
      var needP = nd.needP;
      /* 11/9/2026 (γύρος 21, devil): αγνή του pool που αποκλείεται από το Κ-Γ (ήδη σε 2 γεύματα, έστω και μηδενισμένη) καταγράφεται — δεν είναι σιωπηλή προτίμηση της whey */
      SEC_ORDER.concat(TIER2_ORDER).forEach(function (n) { if (pool.indexOf(n) >= 0 && FOODS[n] && (dayCnt[n] || 0) >= 2 && names.indexOf(n) < 0) tried.push({ meal: m.name, food: n, why: 'ήδη σε 2 γεύματα της ημέρας (Κ-Γ)' }); });
      /* 9/9/2026 (owner, γύρος 17 #2): ΑΓΝΕΣ τροφές πρώτα, η whey ΤΕΛΕΥΤΑΙΑ (σκόνη = plan B).
         1. δευτερεύουσα έως το ιδανικό της */
      order(SEC_ORDER.filter(function (n) { return inPool(n) && names.indexOf(n) < 0; }), m).forEach(function (n) {
        var fd = FOODS[n]; if (!fitsIn(n, m)) { tried.push({ meal: m.name, food: n, why: 'δεν ταιριάζει' }); return; }
        if (fd.yolkEq && dayYolkEq(meals) + fd.min * fd.yolkEq > YOLK_DAY_CAP) { tried.push({ meal: m.name, food: n, why: 'ταβάνι κρόκων §9.6' }); return; }
        out.push({ mi: mi, food: n, grams: Math.max(fd.min, Math.min(fd.ideal || fd.max, Math.ceil(needP / (fd.p / 100)))), why: nd.why, step: 1 });
      });
      /* 2. τυρί tier2 */
      order(TIER2_ORDER.filter(function (n) { return inPool(n) && names.indexOf(n) < 0; }), m).forEach(function (n) {
        var fd = FOODS[n]; if (!fitsIn(n, m)) { tried.push({ meal: m.name, food: n, why: 'δεν ταιριάζει' }); return; }
        out.push({ mi: mi, food: n, grams: Math.max(fd.min, Math.min(fd.max, Math.ceil(needP / (fd.p / 100)))), why: nd.why, step: 2 });
      });
      /* 3. κύρια — μόνο αν το γεύμα δεν έχει κύρια και η κύρια δεν υπάρχει ήδη τη μέρα (Κ-Δ 1×) */
      if (!m.foods.some(function (it) { return actsAsMain(it, m); })) {
        order(pool.filter(function (n) { return FOODS[n] && FOODS[n].role === 'main' && !FOODS[n].locked && !dayMains[n] && names.indexOf(n) < 0; }), m).forEach(function (n) {
          var fd = FOODS[n]; if (!fitsIn(n, m)) { tried.push({ meal: m.name, food: n, why: 'δεν ταιριάζει' }); return; }
          out.push({ mi: mi, food: n, grams: Math.max(foodMin(fd, spec.sex), Math.min(fd.max, Math.ceil(needP / (fd.p / 100)))), why: nd.why, step: 3 });
        });
      }
      /* 4. whey — τελευταία: ≥25 g, ≤2 γεύματα (§9.7), ποτέ δίπλα σε σολομό/κρέας (fits), όχι Post */
      if (names.indexOf(WHEY_NAME) < 0) {
        if (pool.indexOf(WHEY_NAME) < 0) tried.push({ meal: m.name, food: 'whey', why: 'δεν είναι στα αγαπημένα' });
        else if (wheyMeals >= 2 || !inPool(WHEY_NAME)) tried.push({ meal: m.name, food: 'whey', why: 'ήδη σε 2 γεύματα (§9.7)' });
        else if (!fitsIn(WHEY_NAME, m)) tried.push({ meal: m.name, food: 'whey', why: 'δεν ταιριάζει με ' + names.join('/') });
        else out.push({ mi: mi, food: WHEY_NAME, grams: Math.max(WHEY_ADD_MIN, Math.min(45, Math.ceil(needP / 0.9))), minUse: WHEY_ADD_MIN, why: nd.why, step: 4 });
      }
    });
    /* (δ) υδατάνθρακας πάνω από το ιδανικό → 2ος/3ος υδατάνθρακας που ταιριάζει (§9.8.3: έως το ιδανικό του / 50 g) */
    res.issues.filter(function (i) { return i.type === 'carb-over-ideal'; }).sort(function (a, b) { return (b.grams - b.ideal) - (a.grams - a.ideal); }).forEach(function (i) {
      var mi = byName[i.meal]; if (mi == null || addedMeals[mi]) return;
      var m = meals[mi], names = namesOf(m), fdo = FOODS[i.food];
      if (isPostName(m.name) && names.indexOf(WHEY_NAME) >= 0) return; /* Post shake: μένει 1 γρήγορος Υ (§9.15) */
      var nCarb = m.foods.filter(function (it) { return fdOf(it).role === 'carb' && (it.grams || 0) > 0; }).length;
      if (nCarb >= 3) return;
      var sweetBowl = names.some(function (n) { return SWEET_BOWL.indexOf(n) >= 0; }) && names.indexOf('Cottage 4%') < 0;
      var list = (isMainMeal(m) ? STARCH_ADD : sweetBowl ? ['Βρώμη', 'Μπανάνα', 'Μήλο'] : LIGHT_ADD).filter(function (n) { return inPool(n) && names.indexOf(n) < 0 && (dayCnt[n] || 0) < 2; });
      if (!list.length && !sweetBowl) list = pool.filter(function (n) { return FOODS[n] && FOODS[n].role === 'carb' && n !== 'Μέλι' && n !== 'Χουρμάδες' && names.indexOf(n) < 0 && (dayCnt[n] || 0) < 2; });
      order(list, m).forEach(function (n) {
        var fd = FOODS[n]; if (!fitsIn(n, m)) { tried.push({ meal: m.name, food: n, why: 'δεν ταιριάζει' }); return; }
        out.push({ mi: mi, food: n, grams: Math.max(fd.min, Math.min(fd.ideal || 50, R((i.grams - i.ideal) * fdo.c / fd.c))), why: i.food + ' ' + i.grams + ' g > ιδανικό ' + i.ideal, step: 5 });
      });
    });
    /* (ε) λείπουν kcal με τους υδατάνθρακες στα max (γ2 #23): υδατάνθρακας που ταιριάζει στο γεύμα με τον λιγότερο (όχι Post) */
    if (res.diff.kcal < -25 && res.issues.some(function (i) { return /carb-capacity-infeasible|kcal-out-of-tolerance/.test(i.type) && i.diff < 0; })) {
      var byC = meals.map(function (m, i) { return i; }).filter(function (i) { return !isPostName(meals[i].name) && !addedMeals[i]; }).sort(function (a, b) { return mealTotals(meals[a]).c - mealTotals(meals[b]).c; });
      byC.slice(0, 2).forEach(function (mi) {
        var m = meals[mi], names = namesOf(m);
        var sweetBowl2 = names.some(function (n) { return SWEET_BOWL.indexOf(n) >= 0; }) && names.indexOf('Cottage 4%') < 0;
        var list = (isMainMeal(m) ? STARCH_ADD : sweetBowl2 ? ['Βρώμη', 'Μπανάνα', 'Μήλο'] : LIGHT_ADD).filter(function (n) { return inPool(n) && names.indexOf(n) < 0 && (dayCnt[n] || 0) < 2; });
        order(list, m).forEach(function (n) {
          var fd = FOODS[n]; if (!fitsIn(n, m)) { tried.push({ meal: m.name, food: n, why: 'δεν ταιριάζει' }); return; }
          out.push({ mi: mi, food: n, grams: Math.max(fd.min, Math.min(fd.ideal || 50, Math.ceil(-res.diff.kcal / (fd.kcal / 100)))), why: 'λείπουν ' + (-res.diff.kcal) + ' kcal', step: 6 });
        });
      });
    }
    return { cands: out, tried: tried };
  }

  /* Σκορ αποδοχής μιας προσθήκης: ό,τι είναι ΜΕΣΑ στα όρια §11 (±25 kcal, ±3 g) δεν πρέπει να «νικά» μια πραγματική ανισοκατανομή —
     οι αποκλίσεις εντός ανοχής μετρούν με βάρος 0,2, ο ρεαλισμός (uneven/over-ideal/whey>45/under-min) πλήρως. */
  function acceptScore(res) {
    var x = 0;
    res.issues.forEach(function (i) {
      if (i.type === 'secondary-over-ideal') x += 3 * (i.grams - i.ideal);
      if (i.type === 'protein-uneven') x += 9 * Math.max(0, Math.abs(i.dev) - i.tol);
      if (i.type === 'fat-over-ideal') x += 6 * (i.grams - i.ideal);
      if (i.type === 'carb-over-ideal') x += 2 * (i.grams - i.ideal);
      if (i.type === 'whey-exception') x += 25 * (i.grams - 45);
      if (i.type === 'meal-under-min-protein') x += 9 * (i.min - i.got);
    });
    return (res.withinLimits ? 0 : 100000) + x + 0.2 * (Math.abs(res.diff.kcal) + 4 * Math.abs(res.diff.p) + 9 * Math.abs(res.diff.f));
  }
  function evalDay(meals, spec, issues, ctx) {
    var m2 = clone(meals), i2 = clone(issues);
    finishDay(m2, spec, i2);
    var res = diagnose(m2, spec, i2, { pool: ctx.pool, fits: ctx.fits, added: ctx.added, tried: ctx.tried, notes: [] });
    return { res: res, score: acceptScore(res) };
  }

  function completeDay(st, spec, ctx) {
    var pools = [ctx.pool].concat(ctx.pool2 && ctx.pool2.length ? [ctx.pool2] : []);
    var addedMeals = {}, adds = 0;
    var cur = evalDay(st.meals, spec, st.issues, ctx);
    while (adds < MAX_ADD) {
      if (cur.res.withinLimits && cur.res.realistic !== false && cur.res.diff.p >= -3) break;
      var accepted = null, cands = null;
      for (var pi = 0; pi < pools.length && !accepted; pi++) {
        cands = completionCandidates(st.meals, cur.res, spec, pools[pi], ctx.fits, addedMeals);
        /* κάθε αποκλεισμός υποψήφιας (δεν ταιριάζει, ταβάνι κρόκων, whey σε 2 γεύματα…) καταγράφεται ΠΑΝΤΑ — ο owner/devil βλέπουν γιατί δεν μπήκε η αγνή τροφή */
        cands.tried.forEach(function (x) { if (!ctx.tried.some(function (y) { return y.meal === x.meal && y.food === x.food; })) ctx.tried.push(x); });
        if (!cands.cands.length) continue;
        /* 9/9/2026 (owner γύρος 17 #2): ανά γεύμα δοκιμάζονται έως 5 υποψήφιες με τη σειρά της σκάλας (αγνές πρώτα, whey τελευταία) και επιλέγεται:
           (1) η πρώτη ΑΓΝΗ που ΚΛΕΙΝΕΙ το γεύμα (καμία ανισοκατανομή/υπέρβαση ιδανικού σε αυτό) → (2) η whey αν ΚΛΕΙΝΕΙ → (3) η καλύτερη βελτίωση (αγνή πριν από whey σε ισοπαλία).
           Έτσι 100 g γιαούρτι που βελτιώνει «λίγο» δεν καίει τη μία προσθήκη του γεύματος ενώ η whey θα το έκλεινε (sweep Γ m/rest/5γ 80 bulk). */
        var seenPair = {}, groups = [], gidx = {};
        cands.cands.forEach(function (c) { var gk = c.mi + '|' + (c.step >= 5 ? 'c' : 'p'); if (gidx[gk] == null) { gidx[gk] = groups.length; groups.push([]); } groups[gidx[gk]].push(c); }); /* ομάδα = γεύμα × είδος (πρωτεΐνη/υδατάνθρακας) — οι υδατάνθρακες δεν «τρώνε» τις αξιολογήσεις των αγνών πρωτεϊνών */
        for (var gi = 0; gi < groups.length && !accepted; gi++) {
          var evals = [], mealName0 = st.meals[groups[gi][0].mi].name, resolvedPure = false;
          for (var ci = 0; ci < groups[gi].length && evals.length < 8; ci++) {
            var c = groups[gi][ci], pair = c.mi + '|' + c.food;
            if (seenPair[pair] || ctx.triedPairs[pair]) continue;
            if (c.food === WHEY_NAME && resolvedPure) break; /* η whey αξιολογείται ΜΟΝΟ αν καμία αγνή δεν έκλεισε το γεύμα */
            seenPair[pair] = 1;
            var trial = clone(st.meals), trialIssues = clone(st.issues);
            trial[c.mi].foods.push({ name: c.food, grams: c.grams, added: true, minUse: c.minUse || undefined });
            runLoop(trial, spec, trialIssues, 1);
            var ev = evalDay(trial, spec, trialIssues, ctx);
            var improves = ev.score < cur.score - 0.5;
            var resolves = improves && !ev.res.issues.some(function (i) { return i.meal === mealName0 && ((i.type === 'protein-uneven' && i.dev < 0) || i.type === 'secondary-over-ideal' || i.type === 'carb-over-ideal' || i.type === 'meal-under-min-protein'); });
            evals.push({ c: c, trial: trial, issues: trialIssues, ev: ev, improves: improves, resolves: resolves, whey: c.food === WHEY_NAME, pair: pair });
            if (resolves && c.food !== WHEY_NAME) resolvedPure = true;
          }
          var pick = null;
          for (var e1 = 0; e1 < evals.length && !pick; e1++) if (evals[e1].resolves && !evals[e1].whey) pick = evals[e1];
          for (var e2 = 0; e2 < evals.length && !pick; e2++) if (evals[e2].resolves && evals[e2].whey) pick = evals[e2];
          if (!pick) evals.forEach(function (e) { if (e.improves && (!pick || e.ev.score < pick.ev.score - 0.5)) pick = e; });
          evals.forEach(function (e) { if (e !== pick) { if (!e.improves) ctx.triedPairs[e.pair] = 1; ctx.tried.push({ meal: mealName0, food: e.c.food, why: e.improves ? 'βελτίωνε αλλά δεν έκλεινε το γεύμα (σκορ ' + R(e.ev.score) + ')' : 'δεν βελτίωσε (σκορ ' + R(e.ev.score) + ' vs ' + R(cur.score) + ')' }); } });
          if (pick) accepted = { c: pick.c, trial: pick.trial, issues: pick.issues, ev: pick.ev };
        }
      }
      if (!accepted) break;
      var mealName = st.meals[accepted.c.mi].name;
      var finalG = 0; accepted.ev.res.meals[accepted.c.mi].items.forEach(function (it) { if (it.name === accepted.c.food) finalG = it.grams; });
      var rec = { meal: mealName, food: accepted.c.food, grams: finalG || accepted.c.grams, why: accepted.c.why, step: accepted.c.step };
      if (spec.suggestOnly) { ctx.suggest = rec; break; } /* Ζ.1: δρόμος γεύμα-γεύμα — πρόταση με ένα πάτημα, όχι αυτόματη προσθήκη */
      st.meals = accepted.trial; st.issues = accepted.issues; cur = accepted.ev;
      addedMeals[accepted.c.mi] = 1; adds++;
      ctx.added.push(rec);
      ctx.notes.push({ type: adds === 3 ? 'third-add' : 'add', meal: mealName, why: rec.food + ' ' + rec.grams + ' g — ' + rec.why }); /* αρχή owner 9/9: η 3η προσθήκη είναι ΕΝΔΕΙΞΗ, μετριέται στην τράπουλα */
    }
    return cur;
  }

  function solveDayFixed(spec, mealsInput) {
    var meals = clone(mealsInput), issues = [];
    prepareMeals(meals, spec);
    preFeasibility(meals, spec, issues);
    var st = { meals: meals, issues: issues };
    runLoop(st.meals, spec, st.issues, 0);
    var pool = (spec.pool || []).filter(function (n) { return !!FOODS[n]; });
    var ctx = { pool: spec.pool ? pool : null, pool2: (spec.pool2 || []).filter(function (n) { return !!FOODS[n]; }), fits: spec.fits || null, added: [], tried: [], triedPairs: {}, notes: [], suggest: null };
    if (spec.pool) completeDay(st, spec, ctx);
    finishDay(st.meals, spec, st.issues);
    return diagnose(st.meals, spec, st.issues, ctx);
  }

  /* ---------- Κύριος solver: global επιλογή κλειδωμένων μερίδων §9.1/Γ2 (σολομός 125/250, τόνος 112/224) ---------- */
  function solveDay(spec) {
    /* spec: { sex, dayType: 'workout'|'rest', targets:{kcal,p,f}, meals:[{name, foods:[{name, units?}]}],
              autoFats?: [λιπαρά του χρήστη, §9.6 B8], pool?: [ΟΛΕΣ οι αποδεκτές τροφές — Β.4 συμπλήρωση], pool2?: [εφεδρικό pool, Ζ.1 «τα κλασικά»],
              fits?(name, mealNames, mealName) → bool (πίνακας ταιριάσματος — χωρίς callback όλα ταιριάζουν), pairScore?(a,b), suggestOnly?: bool (Ζ.1),
              lockedCombo?: [g…] (QA: επιβολή συγκεκριμένων κλειδωμένων τιμών) } */
    var issues = [];
    spec.meals.forEach(function (m) {
      m.foods.forEach(function (it) {
        if (!fdOf(it)) issues.push({ type: 'unknown-food', food: it.name });
      });
    });
    if (issues.length) return { ok: false, issues: issues };
    if (!spec.autoFats && spec.pool && !spec.suggestOnly) spec.autoFats = spec.pool.filter(function (n) { return FOODS[n] && FOODS[n].role === 'fat'; }); /* γρήγορος δρόμος: λιπαρά από τα αγαπημένα (B8)· δρόμος γεύμα-γεύμα: καρύδια/αμύγδαλα όπως πριν */

    /* εντόπισε locked θέσεις και δοκίμασε όλους τους συνδυασμούς (≤4 λύσεις) */
    var slots = [];
    spec.meals.forEach(function (m, mi) {
      m.foods.forEach(function (it, fi) {
        if (fdOf(it).locked) slots.push({ mi: mi, fi: fi });
      });
    });
    var combos = [[]];
    slots.slice(0, 2).forEach(function (sl) { /* 6/9: κάθε κλειδωμένη τροφή με τις δικές της τιμές (σολομός 125/250, τόνος 112/224) */
      var vals = fdOf(spec.meals[sl.mi].foods[sl.fi]).locked, next = [];
      combos.forEach(function (c) { vals.forEach(function (v) { next.push(c.concat(v)); }); });
      combos = next;
    });
    if (spec.lockedCombo) combos = [spec.lockedCombo];

    var best = null;
    var mealShare = spec.targets.kcal / spec.meals.length, pShare = spec.targets.p / spec.meals.length;
    combos.forEach(function (combo) {
      var meals = clone(spec.meals);
      combo.forEach(function (g, k) {
        if (slots[k]) meals[slots[k].mi].foods[slots[k].fi].grams = g;
      });
      var res = solveDayFixed(spec, meals);
      /* §9.1 tie-break: φιλέτο που ξεπερνά το kcal μερίδιο του γεύματος «τρώει» το budget της ημέρας (cut χαμηλών θερμίδων → 125g) — ποινή στο σκορ αναλογικά */
      var salmonPenalty = 0;
      combo.forEach(function (g, k) {
        var lfd = slots[k] ? fdOf(spec.meals[slots[k].mi].foods[slots[k].fi]) : FOODS['Σολωμός'];
        salmonPenalty += Math.max(0, lfd.kcal * g / 100 - mealShare) * 0.5;
      });
      /* v3 (Β.1, #13): το ΚΛΕΙΔΩΜΕΝΟ γεύμα δεν έχει target — αλλά η επιλογή 112/224 · 125/250 προτιμά την τιμή που το φέρνει πιο κοντά στο μερίδιό του
         (στόχος / όλα τα γεύματα, ±15)· έτσι «Τοστ με τόνο» σε Pre 35 g παίρνει 1 κονσέρβα, εκτός αν η ημέρα δεν κλείνει αλλιώς (το 100000 αποφασίζει). */
      var lockedPenalty = 0;
      res.meals.forEach(function (m) { if (m.locked) lockedPenalty += 9 * Math.max(0, Math.abs(m.totals.p - pShare) - 15); });
      var score = solverScore(res) + salmonPenalty + lockedPenalty;
      if (!best || score < best.score) best = { res: res, score: score, combo: combo };
    });
    best.res.score = R(best.score); best.res.combo = best.combo;
    return best.res;
  }

  /* ---------- Β.7 (Ζ.5, owner 9/9/2026): hook για την ΕΒΔΟΜΑΔΑ (§9.17.3) — υλοποιείται στο batch «εβδομάδα» ----------
     Ίδιο primitive «κλειδωμένα πρώτα → υπόλοιπα → μεταφορά → συμπλήρωση → δήλωση» σε επίπεδο θέσεων κύριων γευμάτων:
     W1 τροφές με ΜΕΓΙΣΤΟ εβδομάδας (τόνος 1, συκώτι 1, αλλαντικό 1, μοσχάρι 1) κλειδώνουν από 1 θέση σε διαφορετικές μέρες ·
     W2 ελάχιστα (σολομός 1, γαρίδες 1, όσπρια 2) · W3 γέμισμα με ισοκατανομή εμφανίσεων · W4 ΜΕΤΑΦΟΡΑ: αν μια μέρα βγαίνει Α/Β από το dayVerdict,
     η κλειδωμένη κύρια της (π.χ. τόνος) μετακινείται σε άλλη μέρα ΠΡΙΝ βγει μήνυμα — και καταγράφεται note {type:'tuna-move', meal, why} ·
     W5 δήλωση μόνο αν σε καμία μέρα δεν χωρά. Ο χτίστης εβδομάδας καλεί dayVerdict(res) ανά μέρα και διαβάζει res.lockedMeals για το τι μπορεί να κουνήσει. */
  function dayVerdict(res) {
    if (!res || !res.ok) return { level: 'A', reasons: ['solver ok=false'] };
    var hard = res.issues.filter(function (i) { return /tolerance|infeasible|overflow|under-min|min-exceeds|conflict/.test(i.type); });
    if (hard.length) return { level: 'A', reasons: hard.map(function (i) { return i.type; }), lockedMeals: lockedOf(res) };
    var soft = res.issues.filter(function (i) { return i.type === 'protein-uneven' || i.type === 'secondary-over-ideal' || i.type === 'carb-over-ideal'; });
    if (soft.length) return { level: 'B', reasons: soft.map(function (i) { return i.type + '@' + i.meal; }), lockedMeals: lockedOf(res) };
    return { level: 'ok', reasons: [], lockedMeals: lockedOf(res) };
  }
  function lockedOf(res) { return res.meals.filter(function (m) { return m.locked; }).map(function (m) { return { meal: m.name, foods: m.items.filter(function (it) { return FOODS[it.name] && (FOODS[it.name].locked || FOODS[it.name].role === 'container'); }).map(function (it) { return it.name; }) }; }); }

  window.RLPlan = { FOODS: FOODS, solveDay: solveDay, allocateProtein: allocateProtein, dayTotals: dayTotals, solverScore: solverScore, dayVerdict: dayVerdict, V: 'v3',
    _t: { transferProtein: transferProtein, proteinLadder: proteinLadder, mealTotals: mealTotals, balanceProteinDay: balanceProteinDay, prepareMeals: prepareMeals } }; /* εσωτερικά για tests/debug (ΟΧΙ API) */
})();
